// ------ DO NOT ALTER THIS FILE ------
// Any changes to this file will be reverted as this file is generated automatically by many of our APIs.
// For code removal information, read the comments at the top of the file located at 'snippets/appikon-discounts.liquid'
// ------ DO NOT ALTER THIS FILE ------
function hasFlag(t) {
  return 1 == window.appikonDiscount.settings.flags[t];
}
function getUrlParam(t) {
  return new URLSearchParams(window.location.search).get(t);
}
(window.appikonDiscount = {}),
  (window.appikonDiscount.settings = {
    debug: !1,
    dp: {
      installed: !0,
      vd_table_type: "default",
      vd_product_message: "Buy at discounted prices",
    },
    delay_mobile_refresh_cart: 2,
    delay_refresh_cart: 0.5,
    discount_method: "DRAFT",
    hide_paypal: !0,
    show_discount_code: !0,
    avoid_cart_quantity_adjustment: !1,
    show_notification_bar: !0,
    show_cart_notification_bar: !1,
    show_product_notification_bar: !1,
    turn_off_agree_checkbox: !1,
    calculation_note: "Please wait while we calculate your cart totals",
    plus_minus_qty_selector: "",
    checkout_selector: "",
    drawer_cart_selector: "",
    drawer_cart_product_title_selector: "",
    drawer_cart_line_price_selector:
      "#mini-cart-form > line-item > div > div.line-item__info > div > div.product-item-meta__price-list-container.text--small > div > span",
    drawer_cart_unit_price_selector: "",
    drawer_cart_sub_total_selector: "",
    terms_selector: "",
    regular_cart_product_title_selector: "",
    regular_cart_line_price_selector: "",
    regular_cart_sub_total_selector:
      "#shopify-section-template--14558522572858__main > section > div > div.page-content.page-content--fluid > form > div.cart__aside > safe-sticky > div.cart__recap > div > div > span:nth-child(2) > span",
    regular_cart_unit_price_selector: "",
    is_dynamic_insertion: !0,
    listen_to_ajax_cart_events_strategy: !0,
    draft_order_invoice_load_delay: 500,
    flags: {
      hide_buy_it_now_setting: !1,
      refresh_on_qty_plush_minus: !1,
      refresh_on_qty_change_hard: !1,
      avoid_default_qty_input_event_change: !1,
      notify_about_disocunt_calculations: !1,
      disable_checkout_button: !1,
      quantities_refresh_over_submit: !1,
      enable_quantity_change_reload: !0,
    },
    app_root_url: "/apps/appikon_discounted_pricing",
    vd_placement_settings: {
      placement: "AFTER",
      final_selector: ".price price--large",
    },
    notification_placement_settings: {
      final_selector: null,
      placement: "AFTER",
    },
    notification_cart_placement_settings: {
      final_selector: null,
      placement: "AFTER",
    },
    notification_bar_selector: null,
    shop: "suddora.myshopify.com",
    discount_code_settings: {
      inputPlacementSelector: ".cart__tax-note.text--subdued",
      inputPlacementPosition: "AFTER",
    },
    use_compare_at_price: !1,
    product_page_price_selector: "",
    intercept_fetch_calls: "false",
    page_load_delay: 0,
  }),
  (window.appikonDiscount.settings.global = {
    env: "production",
    appikonCheckoutSelector:
      "input[name='checkout'], button[name='checkout'], [href$='checkout'], input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'], .additional-checkout-button, .google-wallet-button-holder, .amazon-payments-pay-button, button.checkout-button",
    baAddToCartSelector:
      "#AddToCart-product-template, .product-atc-btn, .product-menu-button.product-menu-button-atc, .button-cart, .product-add, .add-to-cart input, .btn-addtocart, [name=add]",
    appikonPlusImageUrl:
      "//cdn.shopify.com/s/files/1/0194/1736/6592/t/1/assets/adp-plus_38x.png?18337618242689679898",
    headerSelector:
      "#shopify-section-header, main, div.content, section.main-content, div#content, section#content",
  }),
  (window.appikon.discount_method =
    window.appikonDiscount.settings.discount_method),
  (window.appikonResponseStore = {}),
  (window.appikonResponseStore.cartJS = ""),
  (window.appikonResponseStore.discountResponse = ""),
  (window.appikon.money_format = "$ {{amount}}"),
  (function (t, e) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define([], e)
      : "object" == typeof exports
      ? (exports.appikonHandlebars = e())
      : (t.appikonHandlebars = e());
  })(this, function () {
    return (
      (n = [
        function (t, e, i) {
          "use strict";
          function n() {
            var i = u();
            return (
              (i.compile = function (t, e) {
                return c.compile(t, e, i);
              }),
              (i.precompile = function (t, e) {
                return c.precompile(t, e, i);
              }),
              (i.AST = s.default),
              (i.Compiler = c.Compiler),
              (i.JavaScriptCompiler = p.default),
              (i.Parser = r.parser),
              (i.parse = r.parse),
              i
            );
          }
          var o = i(1).default;
          e.__esModule = !0;
          var a = o(i(2)),
            s = o(i(35)),
            r = i(36),
            c = i(41),
            p = o(i(42)),
            l = o(i(39)),
            o = o(i(34)),
            u = a.default.create,
            i = n();
          (i.create = n),
            o.default(i),
            (i.Visitor = l.default),
            (i.default = i),
            (e.default = i),
            (t.exports = e.default);
        },
        function (t, e) {
          "use strict";
          (e.default = function (t) {
            return t && t.__esModule ? t : { default: t };
          }),
            (e.__esModule = !0);
        },
        function (t, e, i) {
          "use strict";
          function n() {
            var e = new s.appikonHandlebarsEnvironment();
            return (
              p.extend(e, s),
              (e.SafeString = r.default),
              (e.Exception = c.default),
              (e.Utils = p),
              (e.escapeExpression = p.escapeExpression),
              (e.VM = l),
              (e.template = function (t) {
                return l.template(t, e);
              }),
              e
            );
          }
          var o = i(3).default,
            a = i(1).default;
          e.__esModule = !0;
          var s = o(i(4)),
            r = a(i(21)),
            c = a(i(6)),
            p = o(i(5)),
            l = o(i(22)),
            o = a(i(34)),
            a = n();
          (a.create = n),
            o.default(a),
            (a.default = a),
            (e.default = a),
            (t.exports = e.default);
        },
        function (t, e) {
          "use strict";
          (e.default = function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t)
              for (var i in t)
                Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return (e.default = t), e;
          }),
            (e.__esModule = !0);
        },
        function (t, e, i) {
          "use strict";
          function n(t, e, i) {
            (this.helpers = t || {}),
              (this.partials = e || {}),
              (this.decorators = i || {}),
              r.registerDefaultHelpers(this),
              c.registerDefaultDecorators(this);
          }
          var o = i(1).default,
            a =
              ((e.__esModule = !0), (e.appikonHandlebarsEnvironment = n), i(5)),
            s = o(i(6)),
            r = i(10),
            c = i(18),
            o = o(i(20)),
            p =
              ((e.VERSION = "4.0.8"),
              (e.COMPILER_REVISION = 7),
              (e.REVISION_CHANGES = {
                1: "<= 1.0.rc.2",
                2: "== 1.0.0-rc.3",
                3: "== 1.0.0-rc.4",
                4: "== 1.x.x",
                5: "== 2.0.0-alpha.x",
                6: ">= 2.0.0-beta.1",
                7: ">= 4.0.0",
              }),
              "[object Object]"),
            i =
              ((n.prototype = {
                constructor: n,
                logger: o.default,
                log: o.default.log,
                registerHelper: function (t, e) {
                  if (a.toString.call(t) === p) {
                    if (e)
                      throw new s.default(
                        "Arg not supported with multiple helpers"
                      );
                    a.extend(this.helpers, t);
                  } else this.helpers[t] = e;
                },
                unregisterHelper: function (t) {
                  delete this.helpers[t];
                },
                registerPartial: function (t, e) {
                  if (a.toString.call(t) === p) a.extend(this.partials, t);
                  else {
                    if (void 0 === e)
                      throw new s.default(
                        'Attempting to register a partial called "' +
                          t +
                          '" as undefined'
                      );
                    this.partials[t] = e;
                  }
                },
                unregisterPartial: function (t) {
                  delete this.partials[t];
                },
                registerDecorator: function (t, e) {
                  if (a.toString.call(t) === p) {
                    if (e)
                      throw new s.default(
                        "Arg not supported with multiple decorators"
                      );
                    a.extend(this.decorators, t);
                  } else this.decorators[t] = e;
                },
                unregisterDecorator: function (t) {
                  delete this.decorators[t];
                },
              }),
              o.default.log);
          (e.log = i), (e.createFrame = a.createFrame), (e.logger = o.default);
        },
        function (t, e) {
          "use strict";
          function i(t) {
            return o[t];
          }
          function n(t) {
            for (var e = 1; e < arguments.length; e++)
              for (var i in arguments[e])
                Object.prototype.hasOwnProperty.call(arguments[e], i) &&
                  (t[i] = arguments[e][i]);
            return t;
          }
          (e.__esModule = !0),
            (e.extend = n),
            (e.indexOf = function (t, e) {
              for (var i = 0, n = t.length; i < n; i++)
                if (t[i] === e) return i;
              return -1;
            }),
            (e.escapeExpression = function (t) {
              if ("string" != typeof t) {
                if (t && t.toHTML) return t.toHTML();
                if (null == t) return "";
                if (!t) return t + "";
                t = "" + t;
              }
              return s.test(t) ? t.replace(a, i) : t;
            }),
            (e.isEmpty = function (t) {
              return (!t && 0 !== t) || !(!p(t) || 0 !== t.length);
            }),
            (e.createFrame = function (t) {
              var e = n({}, t);
              return (e._parent = t), e;
            }),
            (e.blockParams = function (t, e) {
              return (t.path = e), t;
            }),
            (e.appendContextPath = function (t, e) {
              return (t ? t + "." : "") + e;
            });
          var o = {
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#x27;",
              "`": "&#x60;",
              "=": "&#x3D;",
            },
            a = /[&<>"'`=]/g,
            s = /[&<>"'`=]/,
            r = Object.prototype.toString,
            c =
              ((e.toString = r),
              function (t) {
                return "function" == typeof t;
              }),
            p =
              (c(/x/) &&
                (e.isFunction = c =
                  function (t) {
                    return (
                      "function" == typeof t &&
                      "[object Function]" === r.call(t)
                    );
                  }),
              (e.isFunction = c),
              Array.isArray ||
                function (t) {
                  return (
                    !(!t || "object" != typeof t) &&
                    "[object Array]" === r.call(t)
                  );
                });
          e.isArray = p;
        },
        function (t, e, i) {
          "use strict";
          function s(t, e) {
            var e = e && e.loc,
              i = void 0,
              n = void 0;
            e && (t += " - " + (i = e.start.line) + ":" + (n = e.start.column));
            for (
              var o = Error.prototype.constructor.call(this, t), a = 0;
              a < c.length;
              a++
            )
              this[c[a]] = o[c[a]];
            Error.captureStackTrace && Error.captureStackTrace(this, s);
            try {
              e &&
                ((this.lineNumber = i),
                r
                  ? Object.defineProperty(this, "column", {
                      value: n,
                      enumerable: !0,
                    })
                  : (this.column = n));
            } catch (t) {}
          }
          var r = i(7).default,
            c =
              ((e.__esModule = !0),
              [
                "description",
                "fileName",
                "lineNumber",
                "message",
                "name",
                "number",
                "stack",
              ]);
          (s.prototype = new Error()), (e.default = s), (t.exports = e.default);
        },
        function (t, e, i) {
          t.exports = { default: i(8), __esModule: !0 };
        },
        function (t, e, i) {
          var n = i(9);
          t.exports = function (t, e, i) {
            return n.setDesc(t, e, i);
          };
        },
        function (t, e) {
          var i = Object;
          t.exports = {
            create: i.create,
            getProto: i.getPrototypeOf,
            isEnum: {}.propertyIsEnumerable,
            getDesc: i.getOwnPropertyDescriptor,
            setDesc: i.defineProperty,
            setDescs: i.defineProperties,
            getKeys: i.keys,
            getNames: i.getOwnPropertyNames,
            getSymbols: i.getOwnPropertySymbols,
            each: [].forEach,
          };
        },
        function (t, e, i) {
          "use strict";
          var n = i(1).default;
          (e.__esModule = !0),
            (e.registerDefaultHelpers = function (t) {
              o.default(t),
                a.default(t),
                s.default(t),
                r.default(t),
                c.default(t),
                p.default(t),
                l.default(t);
            });
          var o = n(i(11)),
            a = n(i(12)),
            s = n(i(13)),
            r = n(i(14)),
            c = n(i(15)),
            p = n(i(16)),
            l = n(i(17));
        },
        function (t, e, i) {
          "use strict";
          e.__esModule = !0;
          var a = i(5);
          (e.default = function (o) {
            o.registerHelper("blockHelperMissing", function (t, e) {
              var i = e.inverse,
                n = e.fn;
              return !0 === t
                ? n(this)
                : !1 === t || null == t
                ? i(this)
                : a.isArray(t)
                ? 0 < t.length
                  ? (e.ids && (e.ids = [e.name]), o.helpers.each(t, e))
                  : i(this)
                : (e.data &&
                    e.ids &&
                    (((i = a.createFrame(e.data)).contextPath =
                      a.appendContextPath(e.data.contextPath, e.name)),
                    (e = { data: i })),
                  n(t, e));
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          var n = i(1).default,
            h = ((e.__esModule = !0), i(5)),
            d = n(i(6));
          (e.default = function (t) {
            t.registerHelper("each", function (n, t) {
              function e(t, e, i) {
                r &&
                  ((r.key = t),
                  (r.index = e),
                  (r.first = 0 === e),
                  (r.last = !!i),
                  c) &&
                  (r.contextPath = c + t),
                  (s += o(n[t], {
                    data: r,
                    blockParams: h.blockParams([n[t], t], [c + t, null]),
                  }));
              }
              if (!t) throw new d.default("Must pass iterator to #each");
              var o = t.fn,
                i = t.inverse,
                a = 0,
                s = "",
                r = void 0,
                c = void 0;
              if (
                (t.data &&
                  t.ids &&
                  (c = h.appendContextPath(t.data.contextPath, t.ids[0]) + "."),
                h.isFunction(n) && (n = n.call(this)),
                t.data && (r = h.createFrame(t.data)),
                n && "object" == typeof n)
              )
                if (h.isArray(n))
                  for (var p = n.length; a < p; a++)
                    a in n && e(a, a, a === n.length - 1);
                else {
                  var l,
                    u = void 0;
                  for (l in n)
                    n.hasOwnProperty(l) &&
                      (void 0 !== u && e(u, a - 1), (u = l), a++);
                  void 0 !== u && e(u, a - 1, !0);
                }
              return (s = 0 === a ? i(this) : s);
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          var n = i(1).default;
          e.__esModule = !0;
          var o = n(i(6));
          (e.default = function (t) {
            t.registerHelper("helperMissing", function () {
              if (1 !== arguments.length)
                throw new o.default(
                  'Missing helper: "' +
                    arguments[arguments.length - 1].name +
                    '"'
                );
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          e.__esModule = !0;
          var n = i(5);
          (e.default = function (i) {
            i.registerHelper("if", function (t, e) {
              return (
                n.isFunction(t) && (t = t.call(this)),
                (!e.hash.includeZero && !t) || n.isEmpty(t)
                  ? e.inverse(this)
                  : e.fn(this)
              );
            }),
              i.registerHelper("unless", function (t, e) {
                return i.helpers.if.call(this, t, {
                  fn: e.inverse,
                  inverse: e.fn,
                  hash: e.hash,
                });
              });
          }),
            (t.exports = e.default);
        },
        function (t, e) {
          "use strict";
          (e.__esModule = !0),
            (e.default = function (o) {
              o.registerHelper("log", function () {
                for (
                  var t = [void 0], e = arguments[arguments.length - 1], i = 0;
                  i < arguments.length - 1;
                  i++
                )
                  t.push(arguments[i]);
                var n = 1;
                null != e.hash.level
                  ? (n = e.hash.level)
                  : e.data && null != e.data.level && (n = e.data.level),
                  (t[0] = n),
                  o.log.apply(o, t);
              });
            }),
            (t.exports = e.default);
        },
        function (t, e) {
          "use strict";
          (e.__esModule = !0),
            (e.default = function (t) {
              t.registerHelper("lookup", function (t, e) {
                return t && t[e];
              });
            }),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          e.__esModule = !0;
          var o = i(5);
          (e.default = function (t) {
            t.registerHelper("with", function (t, e) {
              o.isFunction(t) && (t = t.call(this));
              var i,
                n = e.fn;
              return o.isEmpty(t)
                ? e.inverse(this)
                : ((i = e.data),
                  e.data &&
                    e.ids &&
                    ((i = o.createFrame(e.data)).contextPath =
                      o.appendContextPath(e.data.contextPath, e.ids[0])),
                  n(t, {
                    data: i,
                    blockParams: o.blockParams([t], [i && i.contextPath]),
                  }));
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          var n = i(1).default;
          (e.__esModule = !0),
            (e.registerDefaultDecorators = function (t) {
              o.default(t);
            });
          var o = n(i(19));
        },
        function (t, e, i) {
          "use strict";
          e.__esModule = !0;
          var s = i(5);
          (e.default = function (t) {
            t.registerDecorator("inline", function (n, o, a, t) {
              var e = n;
              return (
                o.partials ||
                  ((o.partials = {}),
                  (e = function (t, e) {
                    var i = a.partials,
                      t = ((a.partials = s.extend({}, i, o.partials)), n(t, e));
                    return (a.partials = i), t;
                  })),
                (o.partials[t.args[0]] = t.fn),
                e
              );
            });
          }),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          e.__esModule = !0;
          var n = i(5),
            o = {
              methodMap: ["debug", "info", "warn", "error"],
              level: "info",
              lookupLevel: function (t) {
                var e;
                return (t =
                  "string" == typeof t
                    ? 0 <= (e = n.indexOf(o.methodMap, t.toLowerCase()))
                      ? e
                      : parseInt(t, 10)
                    : t);
              },
              log: function (t) {
                if (
                  ((t = o.lookupLevel(t)),
                  "undefined" != typeof console && o.lookupLevel(o.level) <= t)
                ) {
                  t = o.methodMap[t];
                  console[t] || (t = "log");
                  for (
                    var e = arguments.length,
                      i = Array(1 < e ? e - 1 : 0),
                      n = 1;
                    n < e;
                    n++
                  )
                    i[n - 1] = arguments[n];
                  console[t].apply(console, i);
                }
              },
            };
          (e.default = o), (t.exports = e.default);
        },
        function (t, e) {
          "use strict";
          function i(t) {
            this.string = t;
          }
          (e.__esModule = !0),
            (i.prototype.toString = i.prototype.toHTML =
              function () {
                return "" + this.string;
              }),
            (e.default = i),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          function u(n, t, o, a, e, s, r) {
            function i(t) {
              var e =
                  arguments.length <= 1 || void 0 === arguments[1]
                    ? {}
                    : arguments[1],
                i = r;
              return (
                !r ||
                  t == r[0] ||
                  (t === n.nullContext && null === r[0]) ||
                  (i = [t].concat(r)),
                o(
                  n,
                  t,
                  n.helpers,
                  n.partials,
                  e.data || a,
                  s && [e.blockParams].concat(s),
                  i
                )
              );
            }
            return (
              ((i = h(o, i, n, r, a, s)).program = t),
              (i.depth = r ? r.length : 0),
              (i.blockParams = e || 0),
              i
            );
          }
          function s() {
            return "";
          }
          function h(t, e, i, n, o, a) {
            return (
              t.decorator &&
                ((e = t.decorator(e, (t = {}), i, n && n[0], o, a, n)),
                d.extend(e, t)),
              e
            );
          }
          var n = i(23).default,
            o = i(3).default,
            a = i(1).default;
          (e.__esModule = !0),
            (e.checkRevision = function (t) {
              var e = (t && t[0]) || 1,
                i = m.COMPILER_REVISION;
              if (e !== i) {
                if (e < i)
                  throw (
                    ((i = m.REVISION_CHANGES[i]),
                    (e = m.REVISION_CHANGES[e]),
                    new f.default(
                      "Template was precompiled with an older version of appikonHandlebars than the current runtime. Please update your precompiler to a newer version (" +
                        i +
                        ") or downgrade your runtime to an older version (" +
                        e +
                        ")."
                    ))
                  );
                throw new f.default(
                  "Template was precompiled with a newer version of appikonHandlebars than the current runtime. Please update your runtime to a newer version (" +
                    t[1] +
                    ")."
                );
              }
            }),
            (e.template = function (c, r) {
              function p(t) {
                function e(t) {
                  return "" + c.main(l, t, l.helpers, l.partials, a, r, s);
                }
                var i,
                  n,
                  o =
                    arguments.length <= 1 || void 0 === arguments[1]
                      ? {}
                      : arguments[1],
                  a = o.data,
                  s =
                    (p._setup(o),
                    !o.partial &&
                      c.useData &&
                      ((i = t),
                      ((n = a) && "root" in n) ||
                        ((n = n ? m.createFrame(n) : {}).root = i),
                      (a = n)),
                    void 0),
                  r = c.useBlockParams ? [] : void 0;
                return (
                  c.useDepths &&
                    (s = o.depths
                      ? t != o.depths[0]
                        ? [t].concat(o.depths)
                        : o.depths
                      : [t]),
                  (e = h(c.main, e, l, o.depths || [], a, r))(t, o)
                );
              }
              if (!r) throw new f.default("No environment passed to template");
              if (!c || !c.main)
                throw new f.default("Unknown template object: " + typeof c);
              (c.main.decorator = c.main_d), r.VM.checkRevision(c.compiler);
              var l = {
                strict: function (t, e) {
                  if (e in t) return t[e];
                  throw new f.default('"' + e + '" not defined in ' + t);
                },
                lookup: function (t, e) {
                  for (var i = t.length, n = 0; n < i; n++)
                    if (t[n] && null != t[n][e]) return t[n][e];
                },
                lambda: function (t, e) {
                  return "function" == typeof t ? t.call(e) : t;
                },
                escapeExpression: d.escapeExpression,
                invokePartial: function (t, e, i) {
                  i.hash &&
                    ((e = d.extend({}, e, i.hash)), i.ids) &&
                    (i.ids[0] = !0),
                    (t = r.VM.resolvePartial.call(this, t, e, i));
                  var n = r.VM.invokePartial.call(this, t, e, i);
                  if (
                    (null == n &&
                      r.compile &&
                      ((i.partials[i.name] = r.compile(
                        t,
                        c.compilerOptions,
                        r
                      )),
                      (n = i.partials[i.name](e, i))),
                    null == n)
                  )
                    throw new f.default(
                      "The partial " +
                        i.name +
                        " could not be compiled when running in runtime-only mode"
                    );
                  if (i.indent) {
                    for (
                      var o = n.split("\n"), a = 0, s = o.length;
                      a < s && (o[a] || a + 1 !== s);
                      a++
                    )
                      o[a] = i.indent + o[a];
                    n = o.join("\n");
                  }
                  return n;
                },
                fn: function (t) {
                  var e = c[t];
                  return (e.decorator = c[t + "_d"]), e;
                },
                programs: [],
                program: function (t, e, i, n, o) {
                  var a = this.programs[t],
                    s = this.fn(t);
                  return (a =
                    e || o || n || i
                      ? u(this, t, s, e, i, n, o)
                      : a || (this.programs[t] = u(this, t, s)));
                },
                data: function (t, e) {
                  for (; t && e--; ) t = t._parent;
                  return t;
                },
                merge: function (t, e) {
                  var i = t || e;
                  return (i = t && e && t !== e ? d.extend({}, e, t) : i);
                },
                nullContext: n({}),
                noop: r.VM.noop,
                compilerInfo: c.compiler,
              };
              return (
                (p.isTop = !0),
                (p._setup = function (t) {
                  t.partial
                    ? ((l.helpers = t.helpers),
                      (l.partials = t.partials),
                      (l.decorators = t.decorators))
                    : ((l.helpers = l.merge(t.helpers, r.helpers)),
                      c.usePartial &&
                        (l.partials = l.merge(t.partials, r.partials)),
                      (c.usePartial || c.useDecorators) &&
                        (l.decorators = l.merge(t.decorators, r.decorators)));
                }),
                (p._child = function (t, e, i, n) {
                  if (c.useBlockParams && !i)
                    throw new f.default("must pass block params");
                  if (c.useDepths && !n)
                    throw new f.default("must pass parent depths");
                  return u(l, t, c[t], e, 0, i, n);
                }),
                p
              );
            }),
            (e.wrapProgram = u),
            (e.resolvePartial = function (t, e, i) {
              return (
                t
                  ? t.call || i.name || ((i.name = t), (t = i.partials[t]))
                  : (t =
                      "@partial-block" === i.name
                        ? i.data["partial-block"]
                        : i.partials[i.name]),
                t
              );
            }),
            (e.invokePartial = function (t, e, i) {
              var n,
                o = i.data && i.data["partial-block"],
                a =
                  ((i.partial = !0),
                  i.ids &&
                    (i.data.contextPath = i.ids[0] || i.data.contextPath),
                  void 0);
              if (
                (i.fn &&
                  i.fn !== s &&
                  ((i.data = m.createFrame(i.data)),
                  (n = i.fn),
                  (a = i.data["partial-block"] =
                    function (t) {
                      var e =
                        arguments.length <= 1 || void 0 === arguments[1]
                          ? {}
                          : arguments[1];
                      return (
                        (e.data = m.createFrame(e.data)),
                        (e.data["partial-block"] = o),
                        n(t, e)
                      );
                    }),
                  n.partials &&
                    (i.partials = d.extend({}, i.partials, n.partials))),
                void 0 === (t = void 0 === t && a ? a : t))
              )
                throw new f.default(
                  "The partial " + i.name + " could not be found"
                );
              if (t instanceof Function) return t(e, i);
            }),
            (e.noop = s);
          var d = o(i(5)),
            f = a(i(6)),
            m = i(4);
        },
        function (t, e, i) {
          t.exports = { default: i(24), __esModule: !0 };
        },
        function (t, e, i) {
          i(25), (t.exports = i(30).Object.seal);
        },
        function (t, e, i) {
          var n = i(26);
          i(27)("seal", function (e) {
            return function (t) {
              return e && n(t) ? e(t) : t;
            };
          });
        },
        function (t, e) {
          t.exports = function (t) {
            return "object" == typeof t ? null !== t : "function" == typeof t;
          };
        },
        function (t, e, i) {
          var o = i(28),
            a = i(30),
            s = i(33);
          t.exports = function (t, e) {
            var i = (a.Object || {})[t] || Object[t],
              n = {};
            (n[t] = e(i)),
              o(
                o.S +
                  o.F *
                    s(function () {
                      i(1);
                    }),
                "Object",
                n
              );
          };
        },
        function (t, e, i) {
          function f(t, e, i) {
            var n,
              o,
              a,
              s = t & f.F,
              r = t & f.G,
              c = t & f.S,
              p = t & f.P,
              l = t & f.B,
              u = t & f.W,
              h = r ? k : k[e] || (k[e] = {}),
              d = r ? m : c ? m[e] : (m[e] || {})[g];
            for (n in (i = r ? e : i))
              (o = !s && d && n in d),
                (o && n in h) ||
                  ((a = (o ? d : i)[n]),
                  (h[n] =
                    r && "function" != typeof d[n]
                      ? i[n]
                      : l && o
                      ? _(a, m)
                      : u && d[n] == a
                      ? (function (e) {
                          function t(t) {
                            return this instanceof e ? new e(t) : e(t);
                          }
                          return (t[g] = e[g]), t;
                        })(a)
                      : p && "function" == typeof a
                      ? _(Function.call, a)
                      : a),
                  p && ((h[g] || (h[g] = {}))[n] = a));
          }
          var m = i(29),
            k = i(30),
            _ = i(31),
            g = "prototype";
          (f.F = 1),
            (f.G = 2),
            (f.S = 4),
            (f.P = 8),
            (f.B = 16),
            (f.W = 32),
            (t.exports = f);
        },
        function (t, e) {
          t = t.exports =
            "undefined" != typeof window && window.Math == Math
              ? window
              : "undefined" != typeof self && self.Math == Math
              ? self
              : Function("return this")();
          "number" == typeof __g && (__g = t);
        },
        function (t, e) {
          t = t.exports = { version: "1.2.6" };
          "number" == typeof __e && (__e = t);
        },
        function (t, e, i) {
          var a = i(32);
          t.exports = function (n, o, t) {
            if ((a(n), void 0 === o)) return n;
            switch (t) {
              case 1:
                return function (t) {
                  return n.call(o, t);
                };
              case 2:
                return function (t, e) {
                  return n.call(o, t, e);
                };
              case 3:
                return function (t, e, i) {
                  return n.call(o, t, e, i);
                };
            }
            return function () {
              return n.apply(o, arguments);
            };
          };
        },
        function (t, e) {
          t.exports = function (t) {
            if ("function" != typeof t)
              throw TypeError(t + " is not a function!");
            return t;
          };
        },
        function (t, e) {
          t.exports = function (t) {
            try {
              return !!t();
            } catch (t) {
              return !0;
            }
          };
        },
        function (t, e) {
          !function (n) {
            "use strict";
            (e.__esModule = !0),
              (e.default = function (t) {
                var e = void 0 !== n ? n : window,
                  i = e.appikonHandlebars;
                t.noConflict = function () {
                  return (
                    e.appikonHandlebars === t && (e.appikonHandlebars = i), t
                  );
                };
              }),
              (t.exports = e.default);
          }.call(
            e,
            (function () {
              return this;
            })()
          );
        },
        function (t, e) {
          "use strict";
          e.__esModule = !0;
          var i = {
            helpers: {
              helperExpression: function (t) {
                return (
                  "SubExpression" === t.type ||
                  (("MustacheStatement" === t.type ||
                    "BlockStatement" === t.type) &&
                    !!((t.params && t.params.length) || t.hash))
                );
              },
              scopedId: function (t) {
                return /^\.|this\b/.test(t.original);
              },
              simpleId: function (t) {
                return (
                  1 === t.parts.length && !i.helpers.scopedId(t) && !t.depth
                );
              },
            },
          };
          (e.default = i), (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          var n = i(1).default,
            o = i(3).default;
          (e.__esModule = !0),
            (e.parse = function (t, e) {
              return "Program" === t.type
                ? t
                : (((a.default.yy = r).locInfo = function (t) {
                    return new r.SourceLocation(e && e.srcName, t);
                  }),
                  new s.default(e).accept(a.default.parse(t)));
            });
          var a = n(i(37)),
            s = n(i(38)),
            n = o(i(40)),
            o = i(5),
            r = ((e.parser = a.default), {});
          o.extend(r, n);
        },
        function (t, e) {
          "use strict";
          e.__esModule = !0;
          (i = {
            trace: function () {},
            yy: {},
            symbols_: {
              error: 2,
              root: 3,
              program: 4,
              EOF: 5,
              program_repetition0: 6,
              statement: 7,
              mustache: 8,
              block: 9,
              rawBlock: 10,
              partial: 11,
              partialBlock: 12,
              content: 13,
              COMMENT: 14,
              CONTENT: 15,
              openRawBlock: 16,
              rawBlock_repetition_plus0: 17,
              END_RAW_BLOCK: 18,
              OPEN_RAW_BLOCK: 19,
              helperName: 20,
              openRawBlock_repetition0: 21,
              openRawBlock_option0: 22,
              CLOSE_RAW_BLOCK: 23,
              openBlock: 24,
              block_option0: 25,
              closeBlock: 26,
              openInverse: 27,
              block_option1: 28,
              OPEN_BLOCK: 29,
              openBlock_repetition0: 30,
              openBlock_option0: 31,
              openBlock_option1: 32,
              CLOSE: 33,
              OPEN_INVERSE: 34,
              openInverse_repetition0: 35,
              openInverse_option0: 36,
              openInverse_option1: 37,
              openInverseChain: 38,
              OPEN_INVERSE_CHAIN: 39,
              openInverseChain_repetition0: 40,
              openInverseChain_option0: 41,
              openInverseChain_option1: 42,
              inverseAndProgram: 43,
              INVERSE: 44,
              inverseChain: 45,
              inverseChain_option0: 46,
              OPEN_ENDBLOCK: 47,
              OPEN: 48,
              mustache_repetition0: 49,
              mustache_option0: 50,
              OPEN_UNESCAPED: 51,
              mustache_repetition1: 52,
              mustache_option1: 53,
              CLOSE_UNESCAPED: 54,
              OPEN_PARTIAL: 55,
              partialName: 56,
              partial_repetition0: 57,
              partial_option0: 58,
              openPartialBlock: 59,
              OPEN_PARTIAL_BLOCK: 60,
              openPartialBlock_repetition0: 61,
              openPartialBlock_option0: 62,
              param: 63,
              sexpr: 64,
              OPEN_SEXPR: 65,
              sexpr_repetition0: 66,
              sexpr_option0: 67,
              CLOSE_SEXPR: 68,
              hash: 69,
              hash_repetition_plus0: 70,
              hashSegment: 71,
              ID: 72,
              EQUALS: 73,
              blockParams: 74,
              OPEN_BLOCK_PARAMS: 75,
              blockParams_repetition_plus0: 76,
              CLOSE_BLOCK_PARAMS: 77,
              path: 78,
              dataName: 79,
              STRING: 80,
              NUMBER: 81,
              BOOLEAN: 82,
              UNDEFINED: 83,
              NULL: 84,
              DATA: 85,
              pathSegments: 86,
              SEP: 87,
              attributeccept: 0,
              $end: 1,
            },
            terminals_: {
              2: "error",
              5: "EOF",
              14: "COMMENT",
              15: "CONTENT",
              18: "END_RAW_BLOCK",
              19: "OPEN_RAW_BLOCK",
              23: "CLOSE_RAW_BLOCK",
              29: "OPEN_BLOCK",
              33: "CLOSE",
              34: "OPEN_INVERSE",
              39: "OPEN_INVERSE_CHAIN",
              44: "INVERSE",
              47: "OPEN_ENDBLOCK",
              48: "OPEN",
              51: "OPEN_UNESCAPED",
              54: "CLOSE_UNESCAPED",
              55: "OPEN_PARTIAL",
              60: "OPEN_PARTIAL_BLOCK",
              65: "OPEN_SEXPR",
              68: "CLOSE_SEXPR",
              72: "ID",
              73: "EQUALS",
              75: "OPEN_BLOCK_PARAMS",
              77: "CLOSE_BLOCK_PARAMS",
              80: "STRING",
              81: "NUMBER",
              82: "BOOLEAN",
              83: "UNDEFINED",
              84: "NULL",
              85: "DATA",
              87: "SEP",
            },
            productions_: [
              0,
              [3, 2],
              [4, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [13, 1],
              [10, 3],
              [16, 5],
              [9, 4],
              [9, 4],
              [24, 6],
              [27, 6],
              [38, 6],
              [43, 2],
              [45, 3],
              [45, 1],
              [26, 3],
              [8, 5],
              [8, 5],
              [11, 5],
              [12, 3],
              [59, 5],
              [63, 1],
              [63, 1],
              [64, 5],
              [69, 1],
              [71, 3],
              [74, 3],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [56, 1],
              [56, 1],
              [79, 2],
              [78, 1],
              [86, 3],
              [86, 1],
              [6, 0],
              [6, 2],
              [17, 1],
              [17, 2],
              [21, 0],
              [21, 2],
              [22, 0],
              [22, 1],
              [25, 0],
              [25, 1],
              [28, 0],
              [28, 1],
              [30, 0],
              [30, 2],
              [31, 0],
              [31, 1],
              [32, 0],
              [32, 1],
              [35, 0],
              [35, 2],
              [36, 0],
              [36, 1],
              [37, 0],
              [37, 1],
              [40, 0],
              [40, 2],
              [41, 0],
              [41, 1],
              [42, 0],
              [42, 1],
              [46, 0],
              [46, 1],
              [49, 0],
              [49, 2],
              [50, 0],
              [50, 1],
              [52, 0],
              [52, 2],
              [53, 0],
              [53, 1],
              [57, 0],
              [57, 2],
              [58, 0],
              [58, 1],
              [61, 0],
              [61, 2],
              [62, 0],
              [62, 1],
              [66, 0],
              [66, 2],
              [67, 0],
              [67, 1],
              [70, 1],
              [70, 2],
              [76, 1],
              [76, 2],
            ],
            performAction: function (t, e, i, n, o, a, s) {
              var r = a.length - 1;
              switch (o) {
                case 1:
                  return a[r - 1];
                case 2:
                  this.$ = n.prepareProgram(a[r]);
                  break;
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                  this.$ = a[r];
                  break;
                case 9:
                  this.$ = {
                    type: "CommentStatement",
                    value: n.stripComment(a[r]),
                    strip: n.stripFlags(a[r], a[r]),
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 10:
                  this.$ = {
                    type: "ContentStatement",
                    original: a[r],
                    value: a[r],
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 11:
                  this.$ = n.prepareRawBlock(a[r - 2], a[r - 1], a[r], this._$);
                  break;
                case 12:
                  this.$ = { path: a[r - 3], params: a[r - 2], hash: a[r - 1] };
                  break;
                case 13:
                  this.$ = n.prepareBlock(
                    a[r - 3],
                    a[r - 2],
                    a[r - 1],
                    a[r],
                    !1,
                    this._$
                  );
                  break;
                case 14:
                  this.$ = n.prepareBlock(
                    a[r - 3],
                    a[r - 2],
                    a[r - 1],
                    a[r],
                    !0,
                    this._$
                  );
                  break;
                case 15:
                  this.$ = {
                    open: a[r - 5],
                    path: a[r - 4],
                    params: a[r - 3],
                    hash: a[r - 2],
                    blockParams: a[r - 1],
                    strip: n.stripFlags(a[r - 5], a[r]),
                  };
                  break;
                case 16:
                case 17:
                  this.$ = {
                    path: a[r - 4],
                    params: a[r - 3],
                    hash: a[r - 2],
                    blockParams: a[r - 1],
                    strip: n.stripFlags(a[r - 5], a[r]),
                  };
                  break;
                case 18:
                  this.$ = {
                    strip: n.stripFlags(a[r - 1], a[r - 1]),
                    program: a[r],
                  };
                  break;
                case 19:
                  var c = n.prepareBlock(
                      a[r - 2],
                      a[r - 1],
                      a[r],
                      a[r],
                      !1,
                      this._$
                    ),
                    c = n.prepareProgram([c], a[r - 1].loc);
                  (c.chained = !0),
                    (this.$ = { strip: a[r - 2].strip, program: c, chain: !0 });
                  break;
                case 20:
                  this.$ = a[r];
                  break;
                case 21:
                  this.$ = {
                    path: a[r - 1],
                    strip: n.stripFlags(a[r - 2], a[r]),
                  };
                  break;
                case 22:
                case 23:
                  this.$ = n.prepareMustache(
                    a[r - 3],
                    a[r - 2],
                    a[r - 1],
                    a[r - 4],
                    n.stripFlags(a[r - 4], a[r]),
                    this._$
                  );
                  break;
                case 24:
                  this.$ = {
                    type: "PartialStatement",
                    name: a[r - 3],
                    params: a[r - 2],
                    hash: a[r - 1],
                    indent: "",
                    strip: n.stripFlags(a[r - 4], a[r]),
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 25:
                  this.$ = n.preparePartialBlock(
                    a[r - 2],
                    a[r - 1],
                    a[r],
                    this._$
                  );
                  break;
                case 26:
                  this.$ = {
                    path: a[r - 3],
                    params: a[r - 2],
                    hash: a[r - 1],
                    strip: n.stripFlags(a[r - 4], a[r]),
                  };
                  break;
                case 27:
                case 28:
                  this.$ = a[r];
                  break;
                case 29:
                  this.$ = {
                    type: "SubExpression",
                    path: a[r - 3],
                    params: a[r - 2],
                    hash: a[r - 1],
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 30:
                  this.$ = {
                    type: "Hash",
                    pairs: a[r],
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 31:
                  this.$ = {
                    type: "HashPair",
                    key: n.id(a[r - 2]),
                    value: a[r],
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 32:
                  this.$ = n.id(a[r - 1]);
                  break;
                case 33:
                case 34:
                  this.$ = a[r];
                  break;
                case 35:
                  this.$ = {
                    type: "StringLiteral",
                    value: a[r],
                    original: a[r],
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 36:
                  this.$ = {
                    type: "NumberLiteral",
                    value: Number(a[r]),
                    original: Number(a[r]),
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 37:
                  this.$ = {
                    type: "BooleanLiteral",
                    value: "true" === a[r],
                    original: "true" === a[r],
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 38:
                  this.$ = {
                    type: "UndefinedLiteral",
                    original: void 0,
                    value: void 0,
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 39:
                  this.$ = {
                    type: "NullLiteral",
                    original: null,
                    value: null,
                    loc: n.locInfo(this._$),
                  };
                  break;
                case 40:
                case 41:
                  this.$ = a[r];
                  break;
                case 42:
                  this.$ = n.preparePath(!0, a[r], this._$);
                  break;
                case 43:
                  this.$ = n.preparePath(!1, a[r], this._$);
                  break;
                case 44:
                  a[r - 2].push({
                    part: n.id(a[r]),
                    original: a[r],
                    separator: a[r - 1],
                  }),
                    (this.$ = a[r - 2]);
                  break;
                case 45:
                  this.$ = [{ part: n.id(a[r]), original: a[r] }];
                  break;
                case 46:
                  this.$ = [];
                  break;
                case 47:
                  a[r - 1].push(a[r]);
                  break;
                case 48:
                  this.$ = [a[r]];
                  break;
                case 49:
                  a[r - 1].push(a[r]);
                  break;
                case 50:
                  this.$ = [];
                  break;
                case 51:
                  a[r - 1].push(a[r]);
                  break;
                case 58:
                  this.$ = [];
                  break;
                case 59:
                  a[r - 1].push(a[r]);
                  break;
                case 64:
                  this.$ = [];
                  break;
                case 65:
                  a[r - 1].push(a[r]);
                  break;
                case 70:
                  this.$ = [];
                  break;
                case 71:
                  a[r - 1].push(a[r]);
                  break;
                case 78:
                  this.$ = [];
                  break;
                case 79:
                  a[r - 1].push(a[r]);
                  break;
                case 82:
                  this.$ = [];
                  break;
                case 83:
                  a[r - 1].push(a[r]);
                  break;
                case 86:
                  this.$ = [];
                  break;
                case 87:
                  a[r - 1].push(a[r]);
                  break;
                case 90:
                  this.$ = [];
                  break;
                case 91:
                  a[r - 1].push(a[r]);
                  break;
                case 94:
                  this.$ = [];
                  break;
                case 95:
                  a[r - 1].push(a[r]);
                  break;
                case 98:
                  this.$ = [a[r]];
                  break;
                case 99:
                  a[r - 1].push(a[r]);
                  break;
                case 100:
                  this.$ = [a[r]];
                  break;
                case 101:
                  a[r - 1].push(a[r]);
              }
            },
            table: [
              {
                3: 1,
                4: 2,
                5: [2, 46],
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 1: [3] },
              { 5: [1, 4] },
              {
                5: [2, 2],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [1, 12],
                15: [1, 20],
                16: 17,
                19: [1, 23],
                24: 15,
                27: 16,
                29: [1, 21],
                34: [1, 22],
                39: [2, 2],
                44: [2, 2],
                47: [2, 2],
                48: [1, 13],
                51: [1, 14],
                55: [1, 18],
                59: 19,
                60: [1, 24],
              },
              { 1: [2, 1] },
              {
                5: [2, 47],
                14: [2, 47],
                15: [2, 47],
                19: [2, 47],
                29: [2, 47],
                34: [2, 47],
                39: [2, 47],
                44: [2, 47],
                47: [2, 47],
                48: [2, 47],
                51: [2, 47],
                55: [2, 47],
                60: [2, 47],
              },
              {
                5: [2, 3],
                14: [2, 3],
                15: [2, 3],
                19: [2, 3],
                29: [2, 3],
                34: [2, 3],
                39: [2, 3],
                44: [2, 3],
                47: [2, 3],
                48: [2, 3],
                51: [2, 3],
                55: [2, 3],
                60: [2, 3],
              },
              {
                5: [2, 4],
                14: [2, 4],
                15: [2, 4],
                19: [2, 4],
                29: [2, 4],
                34: [2, 4],
                39: [2, 4],
                44: [2, 4],
                47: [2, 4],
                48: [2, 4],
                51: [2, 4],
                55: [2, 4],
                60: [2, 4],
              },
              {
                5: [2, 5],
                14: [2, 5],
                15: [2, 5],
                19: [2, 5],
                29: [2, 5],
                34: [2, 5],
                39: [2, 5],
                44: [2, 5],
                47: [2, 5],
                48: [2, 5],
                51: [2, 5],
                55: [2, 5],
                60: [2, 5],
              },
              {
                5: [2, 6],
                14: [2, 6],
                15: [2, 6],
                19: [2, 6],
                29: [2, 6],
                34: [2, 6],
                39: [2, 6],
                44: [2, 6],
                47: [2, 6],
                48: [2, 6],
                51: [2, 6],
                55: [2, 6],
                60: [2, 6],
              },
              {
                5: [2, 7],
                14: [2, 7],
                15: [2, 7],
                19: [2, 7],
                29: [2, 7],
                34: [2, 7],
                39: [2, 7],
                44: [2, 7],
                47: [2, 7],
                48: [2, 7],
                51: [2, 7],
                55: [2, 7],
                60: [2, 7],
              },
              {
                5: [2, 8],
                14: [2, 8],
                15: [2, 8],
                19: [2, 8],
                29: [2, 8],
                34: [2, 8],
                39: [2, 8],
                44: [2, 8],
                47: [2, 8],
                48: [2, 8],
                51: [2, 8],
                55: [2, 8],
                60: [2, 8],
              },
              {
                5: [2, 9],
                14: [2, 9],
                15: [2, 9],
                19: [2, 9],
                29: [2, 9],
                34: [2, 9],
                39: [2, 9],
                44: [2, 9],
                47: [2, 9],
                48: [2, 9],
                51: [2, 9],
                55: [2, 9],
                60: [2, 9],
              },
              {
                20: 25,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 36,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 37,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {
                4: 38,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 13: 40, 15: [1, 20], 17: 39 },
              {
                20: 42,
                56: 41,
                64: 43,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 45,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {
                5: [2, 10],
                14: [2, 10],
                15: [2, 10],
                18: [2, 10],
                19: [2, 10],
                29: [2, 10],
                34: [2, 10],
                39: [2, 10],
                44: [2, 10],
                47: [2, 10],
                48: [2, 10],
                51: [2, 10],
                55: [2, 10],
                60: [2, 10],
              },
              {
                20: 46,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 47,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 48,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 42,
                56: 49,
                64: 43,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                33: [2, 78],
                49: 50,
                65: [2, 78],
                72: [2, 78],
                80: [2, 78],
                81: [2, 78],
                82: [2, 78],
                83: [2, 78],
                84: [2, 78],
                85: [2, 78],
              },
              {
                23: [2, 33],
                33: [2, 33],
                54: [2, 33],
                65: [2, 33],
                68: [2, 33],
                72: [2, 33],
                75: [2, 33],
                80: [2, 33],
                81: [2, 33],
                82: [2, 33],
                83: [2, 33],
                84: [2, 33],
                85: [2, 33],
              },
              {
                23: [2, 34],
                33: [2, 34],
                54: [2, 34],
                65: [2, 34],
                68: [2, 34],
                72: [2, 34],
                75: [2, 34],
                80: [2, 34],
                81: [2, 34],
                82: [2, 34],
                83: [2, 34],
                84: [2, 34],
                85: [2, 34],
              },
              {
                23: [2, 35],
                33: [2, 35],
                54: [2, 35],
                65: [2, 35],
                68: [2, 35],
                72: [2, 35],
                75: [2, 35],
                80: [2, 35],
                81: [2, 35],
                82: [2, 35],
                83: [2, 35],
                84: [2, 35],
                85: [2, 35],
              },
              {
                23: [2, 36],
                33: [2, 36],
                54: [2, 36],
                65: [2, 36],
                68: [2, 36],
                72: [2, 36],
                75: [2, 36],
                80: [2, 36],
                81: [2, 36],
                82: [2, 36],
                83: [2, 36],
                84: [2, 36],
                85: [2, 36],
              },
              {
                23: [2, 37],
                33: [2, 37],
                54: [2, 37],
                65: [2, 37],
                68: [2, 37],
                72: [2, 37],
                75: [2, 37],
                80: [2, 37],
                81: [2, 37],
                82: [2, 37],
                83: [2, 37],
                84: [2, 37],
                85: [2, 37],
              },
              {
                23: [2, 38],
                33: [2, 38],
                54: [2, 38],
                65: [2, 38],
                68: [2, 38],
                72: [2, 38],
                75: [2, 38],
                80: [2, 38],
                81: [2, 38],
                82: [2, 38],
                83: [2, 38],
                84: [2, 38],
                85: [2, 38],
              },
              {
                23: [2, 39],
                33: [2, 39],
                54: [2, 39],
                65: [2, 39],
                68: [2, 39],
                72: [2, 39],
                75: [2, 39],
                80: [2, 39],
                81: [2, 39],
                82: [2, 39],
                83: [2, 39],
                84: [2, 39],
                85: [2, 39],
              },
              {
                23: [2, 43],
                33: [2, 43],
                54: [2, 43],
                65: [2, 43],
                68: [2, 43],
                72: [2, 43],
                75: [2, 43],
                80: [2, 43],
                81: [2, 43],
                82: [2, 43],
                83: [2, 43],
                84: [2, 43],
                85: [2, 43],
                87: [1, 51],
              },
              { 72: [1, 35], 86: 52 },
              {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45],
              },
              {
                52: 53,
                54: [2, 82],
                65: [2, 82],
                72: [2, 82],
                80: [2, 82],
                81: [2, 82],
                82: [2, 82],
                83: [2, 82],
                84: [2, 82],
                85: [2, 82],
              },
              {
                25: 54,
                38: 56,
                39: [1, 58],
                43: 57,
                44: [1, 59],
                45: 55,
                47: [2, 54],
              },
              { 28: 60, 43: 61, 44: [1, 59], 47: [2, 56] },
              { 13: 63, 15: [1, 20], 18: [1, 62] },
              { 15: [2, 48], 18: [2, 48] },
              {
                33: [2, 86],
                57: 64,
                65: [2, 86],
                72: [2, 86],
                80: [2, 86],
                81: [2, 86],
                82: [2, 86],
                83: [2, 86],
                84: [2, 86],
                85: [2, 86],
              },
              {
                33: [2, 40],
                65: [2, 40],
                72: [2, 40],
                80: [2, 40],
                81: [2, 40],
                82: [2, 40],
                83: [2, 40],
                84: [2, 40],
                85: [2, 40],
              },
              {
                33: [2, 41],
                65: [2, 41],
                72: [2, 41],
                80: [2, 41],
                81: [2, 41],
                82: [2, 41],
                83: [2, 41],
                84: [2, 41],
                85: [2, 41],
              },
              {
                20: 65,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 26: 66, 47: [1, 67] },
              {
                30: 68,
                33: [2, 58],
                65: [2, 58],
                72: [2, 58],
                75: [2, 58],
                80: [2, 58],
                81: [2, 58],
                82: [2, 58],
                83: [2, 58],
                84: [2, 58],
                85: [2, 58],
              },
              {
                33: [2, 64],
                35: 69,
                65: [2, 64],
                72: [2, 64],
                75: [2, 64],
                80: [2, 64],
                81: [2, 64],
                82: [2, 64],
                83: [2, 64],
                84: [2, 64],
                85: [2, 64],
              },
              {
                21: 70,
                23: [2, 50],
                65: [2, 50],
                72: [2, 50],
                80: [2, 50],
                81: [2, 50],
                82: [2, 50],
                83: [2, 50],
                84: [2, 50],
                85: [2, 50],
              },
              {
                33: [2, 90],
                61: 71,
                65: [2, 90],
                72: [2, 90],
                80: [2, 90],
                81: [2, 90],
                82: [2, 90],
                83: [2, 90],
                84: [2, 90],
                85: [2, 90],
              },
              {
                20: 75,
                33: [2, 80],
                50: 72,
                63: 73,
                64: 76,
                65: [1, 44],
                69: 74,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 72: [1, 80] },
              {
                23: [2, 42],
                33: [2, 42],
                54: [2, 42],
                65: [2, 42],
                68: [2, 42],
                72: [2, 42],
                75: [2, 42],
                80: [2, 42],
                81: [2, 42],
                82: [2, 42],
                83: [2, 42],
                84: [2, 42],
                85: [2, 42],
                87: [1, 51],
              },
              {
                20: 75,
                53: 81,
                54: [2, 84],
                63: 82,
                64: 76,
                65: [1, 44],
                69: 83,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 26: 84, 47: [1, 67] },
              { 47: [2, 55] },
              {
                4: 85,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 47: [2, 20] },
              {
                20: 86,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 87,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 26: 88, 47: [1, 67] },
              { 47: [2, 57] },
              {
                5: [2, 11],
                14: [2, 11],
                15: [2, 11],
                19: [2, 11],
                29: [2, 11],
                34: [2, 11],
                39: [2, 11],
                44: [2, 11],
                47: [2, 11],
                48: [2, 11],
                51: [2, 11],
                55: [2, 11],
                60: [2, 11],
              },
              { 15: [2, 49], 18: [2, 49] },
              {
                20: 75,
                33: [2, 88],
                58: 89,
                63: 90,
                64: 76,
                65: [1, 44],
                69: 91,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                65: [2, 94],
                66: 92,
                68: [2, 94],
                72: [2, 94],
                80: [2, 94],
                81: [2, 94],
                82: [2, 94],
                83: [2, 94],
                84: [2, 94],
                85: [2, 94],
              },
              {
                5: [2, 25],
                14: [2, 25],
                15: [2, 25],
                19: [2, 25],
                29: [2, 25],
                34: [2, 25],
                39: [2, 25],
                44: [2, 25],
                47: [2, 25],
                48: [2, 25],
                51: [2, 25],
                55: [2, 25],
                60: [2, 25],
              },
              {
                20: 93,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 75,
                31: 94,
                33: [2, 60],
                63: 95,
                64: 76,
                65: [1, 44],
                69: 96,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 60],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 75,
                33: [2, 66],
                36: 97,
                63: 98,
                64: 76,
                65: [1, 44],
                69: 99,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 66],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 75,
                22: 100,
                23: [2, 52],
                63: 101,
                64: 76,
                65: [1, 44],
                69: 102,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 75,
                33: [2, 92],
                62: 103,
                63: 104,
                64: 76,
                65: [1, 44],
                69: 105,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 33: [1, 106] },
              {
                33: [2, 79],
                65: [2, 79],
                72: [2, 79],
                80: [2, 79],
                81: [2, 79],
                82: [2, 79],
                83: [2, 79],
                84: [2, 79],
                85: [2, 79],
              },
              { 33: [2, 81] },
              {
                23: [2, 27],
                33: [2, 27],
                54: [2, 27],
                65: [2, 27],
                68: [2, 27],
                72: [2, 27],
                75: [2, 27],
                80: [2, 27],
                81: [2, 27],
                82: [2, 27],
                83: [2, 27],
                84: [2, 27],
                85: [2, 27],
              },
              {
                23: [2, 28],
                33: [2, 28],
                54: [2, 28],
                65: [2, 28],
                68: [2, 28],
                72: [2, 28],
                75: [2, 28],
                80: [2, 28],
                81: [2, 28],
                82: [2, 28],
                83: [2, 28],
                84: [2, 28],
                85: [2, 28],
              },
              {
                23: [2, 30],
                33: [2, 30],
                54: [2, 30],
                68: [2, 30],
                71: 107,
                72: [1, 108],
                75: [2, 30],
              },
              {
                23: [2, 98],
                33: [2, 98],
                54: [2, 98],
                68: [2, 98],
                72: [2, 98],
                75: [2, 98],
              },
              {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                73: [1, 109],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45],
              },
              {
                23: [2, 44],
                33: [2, 44],
                54: [2, 44],
                65: [2, 44],
                68: [2, 44],
                72: [2, 44],
                75: [2, 44],
                80: [2, 44],
                81: [2, 44],
                82: [2, 44],
                83: [2, 44],
                84: [2, 44],
                85: [2, 44],
                87: [2, 44],
              },
              { 54: [1, 110] },
              {
                54: [2, 83],
                65: [2, 83],
                72: [2, 83],
                80: [2, 83],
                81: [2, 83],
                82: [2, 83],
                83: [2, 83],
                84: [2, 83],
                85: [2, 83],
              },
              { 54: [2, 85] },
              {
                5: [2, 13],
                14: [2, 13],
                15: [2, 13],
                19: [2, 13],
                29: [2, 13],
                34: [2, 13],
                39: [2, 13],
                44: [2, 13],
                47: [2, 13],
                48: [2, 13],
                51: [2, 13],
                55: [2, 13],
                60: [2, 13],
              },
              {
                38: 56,
                39: [1, 58],
                43: 57,
                44: [1, 59],
                45: 112,
                46: 111,
                47: [2, 76],
              },
              {
                33: [2, 70],
                40: 113,
                65: [2, 70],
                72: [2, 70],
                75: [2, 70],
                80: [2, 70],
                81: [2, 70],
                82: [2, 70],
                83: [2, 70],
                84: [2, 70],
                85: [2, 70],
              },
              { 47: [2, 18] },
              {
                5: [2, 14],
                14: [2, 14],
                15: [2, 14],
                19: [2, 14],
                29: [2, 14],
                34: [2, 14],
                39: [2, 14],
                44: [2, 14],
                47: [2, 14],
                48: [2, 14],
                51: [2, 14],
                55: [2, 14],
                60: [2, 14],
              },
              { 33: [1, 114] },
              {
                33: [2, 87],
                65: [2, 87],
                72: [2, 87],
                80: [2, 87],
                81: [2, 87],
                82: [2, 87],
                83: [2, 87],
                84: [2, 87],
                85: [2, 87],
              },
              { 33: [2, 89] },
              {
                20: 75,
                63: 116,
                64: 76,
                65: [1, 44],
                67: 115,
                68: [2, 96],
                69: 117,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 33: [1, 118] },
              { 32: 119, 33: [2, 62], 74: 120, 75: [1, 121] },
              {
                33: [2, 59],
                65: [2, 59],
                72: [2, 59],
                75: [2, 59],
                80: [2, 59],
                81: [2, 59],
                82: [2, 59],
                83: [2, 59],
                84: [2, 59],
                85: [2, 59],
              },
              { 33: [2, 61], 75: [2, 61] },
              { 33: [2, 68], 37: 122, 74: 123, 75: [1, 121] },
              {
                33: [2, 65],
                65: [2, 65],
                72: [2, 65],
                75: [2, 65],
                80: [2, 65],
                81: [2, 65],
                82: [2, 65],
                83: [2, 65],
                84: [2, 65],
                85: [2, 65],
              },
              { 33: [2, 67], 75: [2, 67] },
              { 23: [1, 124] },
              {
                23: [2, 51],
                65: [2, 51],
                72: [2, 51],
                80: [2, 51],
                81: [2, 51],
                82: [2, 51],
                83: [2, 51],
                84: [2, 51],
                85: [2, 51],
              },
              { 23: [2, 53] },
              { 33: [1, 125] },
              {
                33: [2, 91],
                65: [2, 91],
                72: [2, 91],
                80: [2, 91],
                81: [2, 91],
                82: [2, 91],
                83: [2, 91],
                84: [2, 91],
                85: [2, 91],
              },
              { 33: [2, 93] },
              {
                5: [2, 22],
                14: [2, 22],
                15: [2, 22],
                19: [2, 22],
                29: [2, 22],
                34: [2, 22],
                39: [2, 22],
                44: [2, 22],
                47: [2, 22],
                48: [2, 22],
                51: [2, 22],
                55: [2, 22],
                60: [2, 22],
              },
              {
                23: [2, 99],
                33: [2, 99],
                54: [2, 99],
                68: [2, 99],
                72: [2, 99],
                75: [2, 99],
              },
              { 73: [1, 109] },
              {
                20: 75,
                63: 126,
                64: 76,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                5: [2, 23],
                14: [2, 23],
                15: [2, 23],
                19: [2, 23],
                29: [2, 23],
                34: [2, 23],
                39: [2, 23],
                44: [2, 23],
                47: [2, 23],
                48: [2, 23],
                51: [2, 23],
                55: [2, 23],
                60: [2, 23],
              },
              { 47: [2, 19] },
              { 47: [2, 77] },
              {
                20: 75,
                33: [2, 72],
                41: 127,
                63: 128,
                64: 76,
                65: [1, 44],
                69: 129,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 72],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                5: [2, 24],
                14: [2, 24],
                15: [2, 24],
                19: [2, 24],
                29: [2, 24],
                34: [2, 24],
                39: [2, 24],
                44: [2, 24],
                47: [2, 24],
                48: [2, 24],
                51: [2, 24],
                55: [2, 24],
                60: [2, 24],
              },
              { 68: [1, 130] },
              {
                65: [2, 95],
                68: [2, 95],
                72: [2, 95],
                80: [2, 95],
                81: [2, 95],
                82: [2, 95],
                83: [2, 95],
                84: [2, 95],
                85: [2, 95],
              },
              { 68: [2, 97] },
              {
                5: [2, 21],
                14: [2, 21],
                15: [2, 21],
                19: [2, 21],
                29: [2, 21],
                34: [2, 21],
                39: [2, 21],
                44: [2, 21],
                47: [2, 21],
                48: [2, 21],
                51: [2, 21],
                55: [2, 21],
                60: [2, 21],
              },
              { 33: [1, 131] },
              { 33: [2, 63] },
              { 72: [1, 133], 76: 132 },
              { 33: [1, 134] },
              { 33: [2, 69] },
              { 15: [2, 12] },
              {
                14: [2, 26],
                15: [2, 26],
                19: [2, 26],
                29: [2, 26],
                34: [2, 26],
                47: [2, 26],
                48: [2, 26],
                51: [2, 26],
                55: [2, 26],
                60: [2, 26],
              },
              {
                23: [2, 31],
                33: [2, 31],
                54: [2, 31],
                68: [2, 31],
                72: [2, 31],
                75: [2, 31],
              },
              { 33: [2, 74], 42: 135, 74: 136, 75: [1, 121] },
              {
                33: [2, 71],
                65: [2, 71],
                72: [2, 71],
                75: [2, 71],
                80: [2, 71],
                81: [2, 71],
                82: [2, 71],
                83: [2, 71],
                84: [2, 71],
                85: [2, 71],
              },
              { 33: [2, 73], 75: [2, 73] },
              {
                23: [2, 29],
                33: [2, 29],
                54: [2, 29],
                65: [2, 29],
                68: [2, 29],
                72: [2, 29],
                75: [2, 29],
                80: [2, 29],
                81: [2, 29],
                82: [2, 29],
                83: [2, 29],
                84: [2, 29],
                85: [2, 29],
              },
              {
                14: [2, 15],
                15: [2, 15],
                19: [2, 15],
                29: [2, 15],
                34: [2, 15],
                39: [2, 15],
                44: [2, 15],
                47: [2, 15],
                48: [2, 15],
                51: [2, 15],
                55: [2, 15],
                60: [2, 15],
              },
              { 72: [1, 138], 77: [1, 137] },
              { 72: [2, 100], 77: [2, 100] },
              {
                14: [2, 16],
                15: [2, 16],
                19: [2, 16],
                29: [2, 16],
                34: [2, 16],
                44: [2, 16],
                47: [2, 16],
                48: [2, 16],
                51: [2, 16],
                55: [2, 16],
                60: [2, 16],
              },
              { 33: [1, 139] },
              { 33: [2, 75] },
              { 33: [2, 32] },
              { 72: [2, 101], 77: [2, 101] },
              {
                14: [2, 17],
                15: [2, 17],
                19: [2, 17],
                29: [2, 17],
                34: [2, 17],
                39: [2, 17],
                44: [2, 17],
                47: [2, 17],
                48: [2, 17],
                51: [2, 17],
                55: [2, 17],
                60: [2, 17],
              },
            ],
            defaultActions: {
              4: [2, 1],
              55: [2, 55],
              57: [2, 20],
              61: [2, 57],
              74: [2, 81],
              83: [2, 85],
              87: [2, 18],
              91: [2, 89],
              102: [2, 53],
              105: [2, 93],
              111: [2, 19],
              112: [2, 77],
              117: [2, 97],
              120: [2, 63],
              123: [2, 69],
              124: [2, 12],
              136: [2, 75],
              137: [2, 32],
            },
            parseError: function (t, e) {
              throw new Error(t);
            },
            parse: function (t) {
              var e = this,
                i = [0],
                n = [null],
                o = [],
                a = this.table,
                s = "",
                r = 0,
                c = 0,
                p = 0,
                l =
                  (this.lexer.setInput(t),
                  (this.lexer.yy = this.yy),
                  (this.yy.lexer = this.lexer),
                  void 0 === (this.yy.parser = this).lexer.yylloc &&
                    (this.lexer.yylloc = {}),
                  this.lexer.yylloc),
                u =
                  (o.push(l), this.lexer.options && this.lexer.options.ranges);
              "function" == typeof this.yy.parseError &&
                (this.parseError = this.yy.parseError);
              for (var h, d, f, m, k, _, g, w, y = {}; ; ) {
                if (
                  ((f = i[i.length - 1]),
                  void 0 ===
                    (m =
                      this.defaultActions[f] ||
                      (null == h &&
                        ((v = void 0),
                        (h = v =
                          ("number" != typeof (v = e.lexer.lex() || 1) &&
                            e.symbols_[v]) ||
                          v)),
                      a[f] && a[f][h])) ||
                    !m.length ||
                    !m[0])
                ) {
                  var v;
                  if (!p) {
                    for (k in ((w = []), a[f]))
                      this.terminals_[k] &&
                        2 < k &&
                        w.push("'" + this.terminals_[k] + "'");
                    (v = this.lexer.showPosition
                      ? "Parse error on line " +
                        (r + 1) +
                        ":\n" +
                        this.lexer.showPosition() +
                        "\nExpecting " +
                        w.join(", ") +
                        ", got '" +
                        (this.terminals_[h] || h) +
                        "'"
                      : "Parse error on line " +
                        (r + 1) +
                        ": Unexpected " +
                        (1 == h
                          ? "end of input"
                          : "'" + (this.terminals_[h] || h) + "'")),
                      this.parseError(v, {
                        text: this.lexer.match,
                        token: this.terminals_[h] || h,
                        line: this.lexer.yylineno,
                        loc: l,
                        expected: w,
                      });
                  }
                }
                if (m[0] instanceof Array && 1 < m.length)
                  throw new Error(
                    "Parse Error: multiple actions possible at state: " +
                      f +
                      ", token: " +
                      h
                  );
                switch (m[0]) {
                  case 1:
                    i.push(h),
                      n.push(this.lexer.yytext),
                      o.push(this.lexer.yylloc),
                      i.push(m[1]),
                      (h = null),
                      d
                        ? ((h = d), (d = null))
                        : ((c = this.lexer.yyleng),
                          (s = this.lexer.yytext),
                          (r = this.lexer.yylineno),
                          (l = this.lexer.yylloc),
                          0 < p && p--);
                    break;
                  case 2:
                    if (
                      ((_ = this.productions_[m[1]][1]),
                      (y.$ = n[n.length - _]),
                      (y._$ = {
                        first_line: o[o.length - (_ || 1)].first_line,
                        last_line: o[o.length - 1].last_line,
                        first_column: o[o.length - (_ || 1)].first_column,
                        last_column: o[o.length - 1].last_column,
                      }),
                      u &&
                        (y._$.range = [
                          o[o.length - (_ || 1)].range[0],
                          o[o.length - 1].range[1],
                        ]),
                      void 0 !==
                        (g = this.performAction.call(
                          y,
                          s,
                          c,
                          r,
                          this.yy,
                          m[1],
                          n,
                          o
                        )))
                    )
                      return g;
                    _ &&
                      ((i = i.slice(0, -1 * _ * 2)),
                      (n = n.slice(0, -1 * _)),
                      (o = o.slice(0, -1 * _))),
                      i.push(this.productions_[m[1]][0]),
                      n.push(y.$),
                      o.push(y._$),
                      (g = a[i[i.length - 2]][i[i.length - 1]]),
                      i.push(g);
                    break;
                  case 3:
                    return !0;
                }
              }
              return !0;
            },
          }).lexer = {
            EOF: 1,
            parseError: function (t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function (t) {
              return (
                (this._input = t),
                (this._more = this._less = this.done = !1),
                (this.yylineno = this.yyleng = 0),
                (this.yytext = this.matched = this.match = ""),
                (this.conditionStack = ["INITIAL"]),
                (this.yylloc = {
                  first_line: 1,
                  first_column: 0,
                  last_line: 1,
                  last_column: 0,
                }),
                this.options.ranges && (this.yylloc.range = [0, 0]),
                (this.offset = 0),
                this
              );
            },
            input: function () {
              var t = this._input[0];
              return (
                (this.yytext += t),
                this.yyleng++,
                this.offset++,
                (this.match += t),
                (this.matched += t),
                t.match(/(?:\r\n?|\n).*/g)
                  ? (this.yylineno++, this.yylloc.last_line++)
                  : this.yylloc.last_column++,
                this.options.ranges && this.yylloc.range[1]++,
                (this._input = this._input.slice(1)),
                t
              );
            },
            unput: function (t) {
              var e = t.length,
                i = t.split(/(?:\r\n?|\n)/g),
                t =
                  ((this._input = t + this._input),
                  (this.yytext = this.yytext.substr(
                    0,
                    this.yytext.length - e - 1
                  )),
                  (this.offset -= e),
                  this.match.split(/(?:\r\n?|\n)/g)),
                n =
                  ((this.match = this.match.substr(0, this.match.length - 1)),
                  (this.matched = this.matched.substr(
                    0,
                    this.matched.length - 1
                  )),
                  i.length - 1 && (this.yylineno -= i.length - 1),
                  this.yylloc.range);
              return (
                (this.yylloc = {
                  first_line: this.yylloc.first_line,
                  last_line: this.yylineno + 1,
                  first_column: this.yylloc.first_column,
                  last_column: i
                    ? (i.length === t.length ? this.yylloc.first_column : 0) +
                      t[t.length - i.length].length -
                      i[0].length
                    : this.yylloc.first_column - e,
                }),
                this.options.ranges &&
                  (this.yylloc.range = [n[0], n[0] + this.yyleng - e]),
                this
              );
            },
            more: function () {
              return (this._more = !0), this;
            },
            less: function (t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function () {
              var t = this.matched.substr(
                0,
                this.matched.length - this.match.length
              );
              return (
                (20 < t.length ? "..." : "") + t.substr(-20).replace(/\n/g, "")
              );
            },
            upcomingInput: function () {
              var t = this.match;
              return (
                t.length < 20 && (t += this._input.substr(0, 20 - t.length)),
                (t.substr(0, 20) + (20 < t.length ? "..." : "")).replace(
                  /\n/g,
                  ""
                )
              );
            },
            showPosition: function () {
              var t = this.pastInput(),
                e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            next: function () {
              if (this.done) return this.EOF;
              var t, e, i, n;
              this._input || (this.done = !0),
                this._more || ((this.yytext = ""), (this.match = ""));
              for (
                var o = this._currentRules(), a = 0;
                a < o.length &&
                (!(e = this._input.match(this.rules[o[a]])) ||
                  (t && !(e[0].length > t[0].length)) ||
                  ((t = e), (i = a), this.options.flex));
                a++
              );
              return t
                ? ((n = t[0].match(/(?:\r\n?|\n).*/g)) &&
                    (this.yylineno += n.length),
                  (this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: n
                      ? n[n.length - 1].length -
                        n[n.length - 1].match(/\r?\n?/)[0].length
                      : this.yylloc.last_column + t[0].length,
                  }),
                  (this.yytext += t[0]),
                  (this.match += t[0]),
                  (this.matches = t),
                  (this.yyleng = this.yytext.length),
                  this.options.ranges &&
                    (this.yylloc.range = [
                      this.offset,
                      (this.offset += this.yyleng),
                    ]),
                  (this._more = !1),
                  (this._input = this._input.slice(t[0].length)),
                  (this.matched += t[0]),
                  (n = this.performAction.call(
                    this,
                    this.yy,
                    this,
                    o[i],
                    this.conditionStack[this.conditionStack.length - 1]
                  )),
                  this.done && this._input && (this.done = !1),
                  n || void 0)
                : "" === this._input
                ? this.EOF
                : this.parseError(
                    "Lexical error on line " +
                      (this.yylineno + 1) +
                      ". Unrecognized text.\n" +
                      this.showPosition(),
                    { text: "", token: null, line: this.yylineno }
                  );
            },
            lex: function () {
              var t = this.next();
              return void 0 !== t ? t : this.lex();
            },
            begin: function (t) {
              this.conditionStack.push(t);
            },
            popState: function () {
              return this.conditionStack.pop();
            },
            _currentRules: function () {
              return this.conditions[
                this.conditionStack[this.conditionStack.length - 1]
              ].rules;
            },
            topState: function () {
              return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function (t) {
              this.begin(t);
            },
            options: {},
            performAction: function (t, i, e, n) {
              function o(t, e) {
                return (i.yytext = i.yytext.substr(t, i.yyleng - e));
              }
              switch (e) {
                case 0:
                  if (
                    ("\\\\" === i.yytext.slice(-2)
                      ? (o(0, 1), this.begin("mu"))
                      : "\\" === i.yytext.slice(-1)
                      ? (o(0, 1), this.begin("emu"))
                      : this.begin("mu"),
                    i.yytext)
                  )
                    return 15;
                  break;
                case 1:
                  return 15;
                case 2:
                  return this.popState(), 15;
                case 3:
                  return this.begin("raw"), 15;
                case 4:
                  return (
                    this.popState(),
                    "raw" ===
                    this.conditionStack[this.conditionStack.length - 1]
                      ? 15
                      : ((i.yytext = i.yytext.substr(5, i.yyleng - 9)),
                        "END_RAW_BLOCK")
                  );
                case 5:
                  return 15;
                case 6:
                  return this.popState(), 14;
                case 7:
                  return 65;
                case 8:
                  return 68;
                case 9:
                  return 19;
                case 10:
                  return this.popState(), this.begin("raw"), 23;
                case 11:
                  return 55;
                case 12:
                  return 60;
                case 13:
                  return 29;
                case 14:
                  return 47;
                case 15:
                case 16:
                  return this.popState(), 44;
                case 17:
                  return 34;
                case 18:
                  return 39;
                case 19:
                  return 51;
                case 20:
                  return 48;
                case 21:
                  this.unput(i.yytext), this.popState(), this.begin("com");
                  break;
                case 22:
                  return this.popState(), 14;
                case 23:
                  return 48;
                case 24:
                  return 73;
                case 25:
                case 26:
                  return 72;
                case 27:
                  return 87;
                case 28:
                  break;
                case 29:
                  return this.popState(), 54;
                case 30:
                  return this.popState(), 33;
                case 31:
                  return (i.yytext = o(1, 2).replace(/\\"/g, '"')), 80;
                case 32:
                  return (i.yytext = o(1, 2).replace(/\\'/g, "'")), 80;
                case 33:
                  return 85;
                case 34:
                case 35:
                  return 82;
                case 36:
                  return 83;
                case 37:
                  return 84;
                case 38:
                  return 81;
                case 39:
                  return 75;
                case 40:
                  return 77;
                case 41:
                  return 72;
                case 42:
                  return (i.yytext = i.yytext.replace(/\\([\\\]])/g, "$1")), 72;
                case 43:
                  return "INVALID";
                case 44:
                  return 5;
              }
            },
            rules: [
              /^(?:[^\x00]*?(?=(\{\{)))/,
              /^(?:[^\x00]+)/,
              /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
              /^(?:\{\{\{\{(?=[^\/]))/,
              /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
              /^(?:[^\x00]*?(?=(\{\{\{\{)))/,
              /^(?:[\s\S]*?--(~)?\}\})/,
              /^(?:\()/,
              /^(?:\))/,
              /^(?:\{\{\{\{)/,
              /^(?:\}\}\}\})/,
              /^(?:\{\{(~)?>)/,
              /^(?:\{\{(~)?#>)/,
              /^(?:\{\{(~)?#\*?)/,
              /^(?:\{\{(~)?\/)/,
              /^(?:\{\{(~)?\^\s*(~)?\}\})/,
              /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
              /^(?:\{\{(~)?\^)/,
              /^(?:\{\{(~)?\s*else\b)/,
              /^(?:\{\{(~)?\{)/,
              /^(?:\{\{(~)?&)/,
              /^(?:\{\{(~)?!--)/,
              /^(?:\{\{(~)?![\s\S]*?\}\})/,
              /^(?:\{\{(~)?\*?)/,
              /^(?:=)/,
              /^(?:\.\.)/,
              /^(?:\.(?=([=~}\s\/.)|])))/,
              /^(?:[\/.])/,
              /^(?:\s+)/,
              /^(?:\}(~)?\}\})/,
              /^(?:(~)?\}\})/,
              /^(?:"(\\["]|[^"])*")/,
              /^(?:'(\\[']|[^'])*')/,
              /^(?:@)/,
              /^(?:true(?=([~}\s)])))/,
              /^(?:false(?=([~}\s)])))/,
              /^(?:undefined(?=([~}\s)])))/,
              /^(?:null(?=([~}\s)])))/,
              /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
              /^(?:as\s+\|)/,
              /^(?:\|)/,
              /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
              /^(?:\[(\\\]|[^\]])*\])/,
              /^(?:.)/,
              /^(?:$)/,
            ],
            conditions: {
              mu: {
                rules: [
                  7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
                  23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
                  38, 39, 40, 41, 42, 43, 44,
                ],
                inclusive: !1,
              },
              emu: { rules: [2], inclusive: !1 },
              com: { rules: [6], inclusive: !1 },
              raw: { rules: [3, 4, 5], inclusive: !1 },
              INITIAL: { rules: [0, 1, 44], inclusive: !0 },
            },
          };
          var i = new ((n.prototype = i).Parser = n)();
          function n() {
            this.yy = {};
          }
          (e.default = i), (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          function n() {
            this.options =
              arguments.length <= 0 || void 0 === arguments[0]
                ? {}
                : arguments[0];
          }
          function h(t, e, i) {
            var n = t[(e = void 0 === e ? t.length : e) - 1],
              t = t[e - 2];
            return n
              ? "ContentStatement" === n.type
                ? (t || !i ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(n.original)
                : void 0
              : i;
          }
          function d(t, e, i) {
            var n = t[(e = void 0 === e ? -1 : e) + 1],
              t = t[e + 2];
            return n
              ? "ContentStatement" === n.type
                ? (t || !i ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(n.original)
                : void 0
              : i;
          }
          function f(t, e, i) {
            t = t[null == e ? 0 : e + 1];
            !t ||
              "ContentStatement" !== t.type ||
              (!i && t.rightStripped) ||
              ((e = t.value),
              (t.value = t.value.replace(i ? /^\s+/ : /^[ \t]*\r?\n?/, "")),
              (t.rightStripped = t.value !== e));
          }
          function m(t, e, i) {
            t = t[null == e ? t.length - 1 : e - 1];
            if (t && "ContentStatement" === t.type && (i || !t.leftStripped))
              return (
                (e = t.value),
                (t.value = t.value.replace(i ? /\s+$/ : /[ \t]+$/, "")),
                (t.leftStripped = t.value !== e),
                t.leftStripped
              );
          }
          var o = i(1).default;
          e.__esModule = !0;
          o = o(i(39));
          ((n.prototype = new o.default()).Program = function (t) {
            var e = !this.options.ignoreStandalone,
              i = !this.isRootSeen;
            this.isRootSeen = !0;
            for (var n = t.body, o = 0, a = n.length; o < a; o++) {
              var s,
                r,
                c,
                p,
                l = n[o],
                u = this.accept(l);
              u &&
                ((p = h(n, o, i)),
                (s = d(n, o, i)),
                (r = u.openStandalone && p),
                (c = u.closeStandalone && s),
                (p = u.inlineStandalone && p && s),
                u.close && f(n, o, !0),
                u.open && m(n, o, !0),
                e &&
                  p &&
                  (f(n, o), m(n, o)) &&
                  "PartialStatement" === l.type &&
                  (l.indent = /([ \t]+$)/.exec(n[o - 1].original)[1]),
                e && r && (f((l.program || l.inverse).body), m(n, o)),
                e) &&
                c &&
                (f(n, o), m((l.inverse || l.program).body));
            }
            return t;
          }),
            (n.prototype.BlockStatement =
              n.prototype.DecoratorBlock =
              n.prototype.PartialBlockStatement =
                function (t) {
                  this.accept(t.program), this.accept(t.inverse);
                  var e = t.program || t.inverse,
                    i = t.program && t.inverse,
                    n = i,
                    o = i;
                  if (i && i.chained)
                    for (n = i.body[0].program; o.chained; )
                      o = o.body[o.body.length - 1].program;
                  var a = {
                    open: t.openStrip.open,
                    close: t.closeStrip.close,
                    openStandalone: d(e.body),
                    closeStandalone: h((n || e).body),
                  };
                  return (
                    t.openStrip.close && f(e.body, null, !0),
                    i
                      ? ((i = t.inverseStrip).open && m(e.body, null, !0),
                        i.close && f(n.body, null, !0),
                        t.closeStrip.open && m(o.body, null, !0),
                        !this.options.ignoreStandalone &&
                          h(e.body) &&
                          d(n.body) &&
                          (m(e.body), f(n.body)))
                      : t.closeStrip.open && m(e.body, null, !0),
                    a
                  );
                }),
            (n.prototype.Decorator = n.prototype.MustacheStatement =
              function (t) {
                return t.strip;
              }),
            (n.prototype.PartialStatement = n.prototype.CommentStatement =
              function (t) {
                t = t.strip || {};
                return { inlineStandalone: !0, open: t.open, close: t.close };
              }),
            (e.default = n),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          function n() {
            this.parents = [];
          }
          function o(t) {
            this.acceptRequired(t, "path"),
              this.acceptArray(t.params),
              this.acceptKey(t, "hash");
          }
          function a(t) {
            o.call(this, t),
              this.acceptKey(t, "program"),
              this.acceptKey(t, "inverse");
          }
          function s(t) {
            this.acceptRequired(t, "name"),
              this.acceptArray(t.params),
              this.acceptKey(t, "hash");
          }
          var r = i(1).default;
          e.__esModule = !0;
          var c = r(i(6));
          (n.prototype = {
            constructor: n,
            mutating: !1,
            acceptKey: function (t, e) {
              var i = this.accept(t[e]);
              if (this.mutating) {
                if (i && !n.prototype[i.type])
                  throw new c.default(
                    'Unexpected node type "' +
                      i.type +
                      '" found when accepting ' +
                      e +
                      " on " +
                      t.type
                  );
                t[e] = i;
              }
            },
            acceptRequired: function (t, e) {
              if ((this.acceptKey(t, e), !t[e]))
                throw new c.default(t.type + " requires " + e);
            },
            acceptArray: function (t) {
              for (var e = 0, i = t.length; e < i; e++)
                this.acceptKey(t, e), t[e] || (t.splice(e, 1), e--, i--);
            },
            accept: function (t) {
              if (t) {
                if (!this[t.type])
                  throw new c.default("Unknown type: " + t.type, t);
                this.current && this.parents.unshift(this.current),
                  (this.current = t);
                var e = this[t.type](t);
                return (
                  (this.current = this.parents.shift()),
                  !this.mutating || e ? e : !1 !== e ? t : void 0
                );
              }
            },
            Program: function (t) {
              this.acceptArray(t.body);
            },
            MustacheStatement: o,
            Decorator: o,
            BlockStatement: a,
            DecoratorBlock: a,
            PartialStatement: s,
            PartialBlockStatement: function (t) {
              s.call(this, t), this.acceptKey(t, "program");
            },
            ContentStatement: function () {},
            CommentStatement: function () {},
            SubExpression: o,
            PathExpression: function () {},
            StringLiteral: function () {},
            NumberLiteral: function () {},
            BooleanLiteral: function () {},
            UndefinedLiteral: function () {},
            NullLiteral: function () {},
            Hash: function (t) {
              this.acceptArray(t.pairs);
            },
            HashPair: function (t) {
              this.acceptRequired(t, "value");
            },
          }),
            (e.default = n),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          function p(t, e) {
            var i;
            if (((e = e.path ? e.path.original : e), t.path.original !== e))
              throw (
                ((i = { loc: t.path.loc }),
                new l.default(t.path.original + " doesn't match " + e, i))
              );
          }
          var n = i(1).default;
          (e.__esModule = !0),
            (e.SourceLocation = function (t, e) {
              (this.source = t),
                (this.start = { line: e.first_line, column: e.first_column }),
                (this.end = { line: e.last_line, column: e.last_column });
            }),
            (e.id = function (t) {
              return /^\[.*\]$/.test(t) ? t.substr(1, t.length - 2) : t;
            }),
            (e.stripFlags = function (t, e) {
              return {
                open: "~" === t.charAt(2),
                close: "~" === e.charAt(e.length - 3),
              };
            }),
            (e.stripComment = function (t) {
              return t.replace(/^\{\{~?\!-?-?/, "").replace(/-?-?~?\}\}$/, "");
            }),
            (e.preparePath = function (t, e, i) {
              i = this.locInfo(i);
              for (
                var n = t ? "@" : "", o = [], a = 0, s = 0, r = e.length;
                s < r;
                s++
              ) {
                var c = e[s].part,
                  p = e[s].original !== c;
                if (
                  ((n += (e[s].separator || "") + c),
                  p || (".." !== c && "." !== c && "this" !== c))
                )
                  o.push(c);
                else {
                  if (0 < o.length)
                    throw new l.default("Invalid path: " + n, { loc: i });
                  ".." === c && (a++, 0);
                }
              }
              return {
                type: "PathExpression",
                data: t,
                depth: a,
                parts: o,
                original: n,
                loc: i,
              };
            }),
            (e.prepareMustache = function (t, e, i, n, o, a) {
              var s = "{" !== (s = n.charAt(3) || n.charAt(2)) && "&" !== s;
              return {
                type: /\*/.test(n) ? "Decorator" : "MustacheStatement",
                path: t,
                params: e,
                hash: i,
                escaped: s,
                strip: o,
                loc: this.locInfo(a),
              };
            }),
            (e.prepareRawBlock = function (t, e, i, n) {
              return (
                p(t, i),
                (n = this.locInfo(n)),
                {
                  type: "BlockStatement",
                  path: t.path,
                  params: t.params,
                  hash: t.hash,
                  program: { type: "Program", body: e, strip: {}, loc: n },
                  openStrip: {},
                  inverseStrip: {},
                  closeStrip: {},
                  loc: n,
                }
              );
            }),
            (e.prepareBlock = function (t, e, i, n, o, a) {
              n && n.path && p(t, n);
              var s = /\*/.test(t.open),
                r = ((e.blockParams = t.blockParams), void 0),
                c = void 0;
              if (i) {
                if (s)
                  throw new l.default(
                    "Unexpected inverse block on decorator",
                    i
                  );
                i.chain && (i.program.body[0].closeStrip = n.strip),
                  (c = i.strip),
                  (r = i.program);
              }
              return (
                o && ((o = r), (r = e), (e = o)),
                {
                  type: s ? "DecoratorBlock" : "BlockStatement",
                  path: t.path,
                  params: t.params,
                  hash: t.hash,
                  program: e,
                  inverse: r,
                  openStrip: t.strip,
                  inverseStrip: c,
                  closeStrip: n && n.strip,
                  loc: this.locInfo(a),
                }
              );
            }),
            (e.prepareProgram = function (t, e) {
              var i;
              return {
                type: "Program",
                body: t,
                strip: {},
                loc: (e =
                  !e &&
                  t.length &&
                  ((i = t[0].loc), (t = t[t.length - 1].loc), i) &&
                  t
                    ? {
                        source: i.source,
                        start: { line: i.start.line, column: i.start.column },
                        end: { line: t.end.line, column: t.end.column },
                      }
                    : e),
              };
            }),
            (e.preparePartialBlock = function (t, e, i, n) {
              return (
                p(t, i),
                {
                  type: "PartialBlockStatement",
                  name: t.path,
                  params: t.params,
                  hash: t.hash,
                  program: e,
                  openStrip: t.strip,
                  closeStrip: i && i.strip,
                  loc: this.locInfo(n),
                }
              );
            });
          var l = n(i(6));
        },
        function (t, e, i) {
          "use strict";
          function n() {}
          function o(t) {
            var e;
            t.path.parts ||
              ((e = t.path),
              (t.path = {
                type: "PathExpression",
                data: !1,
                depth: 0,
                parts: [e.original + ""],
                original: e.original + "",
                loc: e.loc,
              }));
          }
          var a = i(1).default;
          (e.__esModule = !0),
            (e.Compiler = n),
            (e.precompile = function (t, e, i) {
              if (null == t || ("string" != typeof t && "Program" !== t.type))
                throw new s.default(
                  "You must pass a string or appikonHandlebars AST to appikonHandlebars.precompile. You passed " +
                    t
                );
              return (
                "data" in (e = e || {}) || (e.data = !0),
                e.compat && (e.useDepths = !0),
                (t = i.parse(t, e)),
                (t = new i.Compiler().compile(t, e)),
                new i.JavaScriptCompiler().compile(t, e)
              );
            }),
            (e.compile = function (e, i, n) {
              function o() {
                var t = n.parse(e, i),
                  t = new n.Compiler().compile(t, i),
                  t = new n.JavaScriptCompiler().compile(t, i, void 0, !0);
                return n.template(t);
              }
              function t(t, e) {
                return (a = a || o()).call(this, t, e);
              }
              if (
                (void 0 === i && (i = {}),
                null == e || ("string" != typeof e && "Program" !== e.type))
              )
                throw new s.default(
                  "You must pass a string or appikonHandlebars AST to appikonHandlebars.compile. You passed " +
                    e
                );
              "data" in i || (i.data = !0), i.compat && (i.useDepths = !0);
              var a = void 0;
              return (
                (t._setup = function (t) {
                  return (a = a || o())._setup(t);
                }),
                (t._child = function (t, e, i, n) {
                  return (a = a || o())._child(t, e, i, n);
                }),
                t
              );
            });
          var s = a(i(6)),
            r = i(5),
            c = a(i(35)),
            p = [].slice;
          n.prototype = {
            compiler: n,
            equals: function (t) {
              var e = this.opcodes.length;
              if (t.opcodes.length !== e) return !1;
              for (var i = 0; i < e; i++) {
                var n = this.opcodes[i],
                  o = t.opcodes[i];
                if (
                  n.opcode !== o.opcode ||
                  !(function t(e, i) {
                    if (e === i) return 1;
                    if (r.isArray(e) && r.isArray(i) && e.length === i.length) {
                      for (var n = 0; n < e.length; n++)
                        if (!t(e[n], i[n])) return;
                      return 1;
                    }
                  })(n.args, o.args)
                )
                  return !1;
              }
              for (e = this.children.length, i = 0; i < e; i++)
                if (!this.children[i].equals(t.children[i])) return !1;
              return !0;
            },
            guid: 0,
            compile: function (t, e) {
              (this.sourceNode = []),
                (this.opcodes = []),
                (this.children = []),
                (this.options = e),
                (this.stringParams = e.stringParams),
                (this.trackIds = e.trackIds),
                (e.blockParams = e.blockParams || []);
              var i = e.knownHelpers;
              if (
                ((e.knownHelpers = {
                  helperMissing: !0,
                  blockHelperMissing: !0,
                  each: !0,
                  if: !0,
                  unless: !0,
                  with: !0,
                  log: !0,
                  lookup: !0,
                }),
                i)
              )
                for (var n in i) n in i && (e.knownHelpers[n] = i[n]);
              return this.accept(t);
            },
            compileProgram: function (t) {
              var t = new this.compiler().compile(t, this.options),
                e = this.guid++;
              return (
                (this.usePartial = this.usePartial || t.usePartial),
                (this.children[e] = t),
                (this.useDepths = this.useDepths || t.useDepths),
                e
              );
            },
            accept: function (t) {
              if (!this[t.type])
                throw new s.default("Unknown type: " + t.type, t);
              this.sourceNode.unshift(t);
              t = this[t.type](t);
              return this.sourceNode.shift(), t;
            },
            Program: function (t) {
              this.options.blockParams.unshift(t.blockParams);
              for (var e = t.body, i = e.length, n = 0; n < i; n++)
                this.accept(e[n]);
              return (
                this.options.blockParams.shift(),
                (this.isSimple = 1 === i),
                (this.blockParams = t.blockParams ? t.blockParams.length : 0),
                this
              );
            },
            BlockStatement: function (t) {
              o(t);
              var e = t.program,
                i = t.inverse,
                e = e && this.compileProgram(e),
                i = i && this.compileProgram(i),
                n = this.classifySexpr(t);
              "helper" === n
                ? this.helperSexpr(t, e, i)
                : "simple" === n
                ? (this.simpleSexpr(t),
                  this.opcode("pushProgram", e),
                  this.opcode("pushProgram", i),
                  this.opcode("emptyHash"),
                  this.opcode("blockValue", t.path.original))
                : (this.ambiguousSexpr(t, e, i),
                  this.opcode("pushProgram", e),
                  this.opcode("pushProgram", i),
                  this.opcode("emptyHash"),
                  this.opcode("ambiguousBlockValue")),
                this.opcode("append");
            },
            DecoratorBlock: function (t) {
              var e = t.program && this.compileProgram(t.program),
                e = this.setupFullMustacheParams(t, e, void 0),
                t = t.path;
              (this.useDecorators = !0),
                this.opcode("registerDecorator", e.length, t.original);
            },
            PartialStatement: function (t) {
              this.usePartial = !0;
              var e = (e = t.program) && this.compileProgram(t.program),
                i = t.params;
              if (1 < i.length)
                throw new s.default(
                  "Unsupported number of partial arguments: " + i.length,
                  t
                );
              i.length ||
                (this.options.explicitPartialContext
                  ? this.opcode("pushLiteral", "undefined")
                  : i.push({ type: "PathExpression", parts: [], depth: 0 }));
              var i = t.name.original,
                n = "SubExpression" === t.name.type,
                e =
                  (n && this.accept(t.name),
                  this.setupFullMustacheParams(t, e, void 0, !0),
                  t.indent || "");
              this.options.preventIndent &&
                e &&
                (this.opcode("appendContent", e), (e = "")),
                this.opcode("invokePartial", n, i, e),
                this.opcode("append");
            },
            PartialBlockStatement: function (t) {
              this.PartialStatement(t);
            },
            MustacheStatement: function (t) {
              this.SubExpression(t),
                t.escaped && !this.options.noEscape
                  ? this.opcode("appendEscaped")
                  : this.opcode("append");
            },
            Decorator: function (t) {
              this.DecoratorBlock(t);
            },
            ContentStatement: function (t) {
              t.value && this.opcode("appendContent", t.value);
            },
            CommentStatement: function () {},
            SubExpression: function (t) {
              o(t);
              var e = this.classifySexpr(t);
              "simple" === e
                ? this.simpleSexpr(t)
                : "helper" === e
                ? this.helperSexpr(t)
                : this.ambiguousSexpr(t);
            },
            ambiguousSexpr: function (t, e, i) {
              var t = t.path,
                n = t.parts[0],
                o = null != e || null != i;
              this.opcode("getContext", t.depth),
                this.opcode("pushProgram", e),
                this.opcode("pushProgram", i),
                (t.strict = !0),
                this.accept(t),
                this.opcode("invokeAmbiguous", n, o);
            },
            simpleSexpr: function (t) {
              t = t.path;
              (t.strict = !0),
                this.accept(t),
                this.opcode("resolvePossibleLambda");
            },
            helperSexpr: function (t, e, i) {
              var e = this.setupFullMustacheParams(t, e, i),
                i = t.path,
                n = i.parts[0];
              if (this.options.knownHelpers[n])
                this.opcode("invokeKnownHelper", e.length, n);
              else {
                if (this.options.knownHelpersOnly)
                  throw new s.default(
                    "You specified knownHelpersOnly, but used the unknown helper " +
                      n,
                    t
                  );
                (i.strict = !0),
                  (i.falsy = !0),
                  this.accept(i),
                  this.opcode(
                    "invokeHelper",
                    e.length,
                    i.original,
                    c.default.helpers.simpleId(i)
                  );
              }
            },
            PathExpression: function (t) {
              this.addDepth(t.depth), this.opcode("getContext", t.depth);
              var e = t.parts[0],
                i = c.default.helpers.scopedId(t),
                n = !t.depth && !i && this.blockParamIndex(e);
              n
                ? this.opcode("lookupBlockParam", n, t.parts)
                : e
                ? t.data
                  ? ((this.options.data = !0),
                    this.opcode("lookupData", t.depth, t.parts, t.strict))
                  : this.opcode(
                      "lookupOnContext",
                      t.parts,
                      t.falsy,
                      t.strict,
                      i
                    )
                : this.opcode("pushContext");
            },
            StringLiteral: function (t) {
              this.opcode("pushString", t.value);
            },
            NumberLiteral: function (t) {
              this.opcode("pushLiteral", t.value);
            },
            BooleanLiteral: function (t) {
              this.opcode("pushLiteral", t.value);
            },
            UndefinedLiteral: function () {
              this.opcode("pushLiteral", "undefined");
            },
            NullLiteral: function () {
              this.opcode("pushLiteral", "null");
            },
            Hash: function (t) {
              var e = t.pairs,
                i = 0,
                n = e.length;
              for (this.opcode("pushHash"); i < n; i++)
                this.pushParam(e[i].value);
              for (; i--; ) this.opcode("assignToHash", e[i].key);
              this.opcode("popHash");
            },
            opcode: function (t) {
              this.opcodes.push({
                opcode: t,
                args: p.call(arguments, 1),
                loc: this.sourceNode[0].loc,
              });
            },
            addDepth: function (t) {
              t && (this.useDepths = !0);
            },
            classifySexpr: function (t) {
              var e = c.default.helpers.simpleId(t.path),
                i = e && !!this.blockParamIndex(t.path.parts[0]),
                n = !i && c.default.helpers.helperExpression(t),
                i = !i && (n || e);
              return (
                i &&
                  !n &&
                  ((e = t.path.parts[0]),
                  (t = this.options).knownHelpers[e]
                    ? (n = !0)
                    : t.knownHelpersOnly && (i = !1)),
                n ? "helper" : i ? "ambiguous" : "simple"
              );
            },
            pushParams: function (t) {
              for (var e = 0, i = t.length; e < i; e++) this.pushParam(t[e]);
            },
            pushParam: function (t) {
              var e,
                i,
                n = null != t.value ? t.value : t.original || "";
              this.stringParams
                ? (n.replace &&
                    (n = n.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")),
                  t.depth && this.addDepth(t.depth),
                  this.opcode("getContext", t.depth || 0),
                  this.opcode("pushStringParam", n, t.type),
                  "SubExpression" === t.type && this.accept(t))
                : (this.trackIds &&
                    ((e = void 0),
                    (e =
                      !t.parts || c.default.helpers.scopedId(t) || t.depth
                        ? e
                        : this.blockParamIndex(t.parts[0]))
                      ? ((i = t.parts.slice(1).join(".")),
                        this.opcode("pushId", "BlockParam", e, i))
                      : ((n = t.original || n).replace &&
                          (n = n
                            .replace(/^this(?:\.|$)/, "")
                            .replace(/^\.\//, "")
                            .replace(/^\.$/, "")),
                        this.opcode("pushId", t.type, n))),
                  this.accept(t));
            },
            setupFullMustacheParams: function (t, e, i, n) {
              var o = t.params;
              return (
                this.pushParams(o),
                this.opcode("pushProgram", e),
                this.opcode("pushProgram", i),
                t.hash ? this.accept(t.hash) : this.opcode("emptyHash", n),
                o
              );
            },
            blockParamIndex: function (t) {
              for (var e = 0, i = this.options.blockParams.length; e < i; e++) {
                var n = this.options.blockParams[e],
                  o = n && r.indexOf(n, t);
                if (n && 0 <= o) return [e, o];
              }
            },
          };
        },
        function (t, e, i) {
          "use strict";
          function r(t) {
            this.value = t;
          }
          function n() {}
          var o = i(1).default,
            a = ((e.__esModule = !0), i(4)),
            h = o(i(6)),
            s = i(5),
            c = o(i(43));
          n.prototype = {
            nameLookup: function (t, e) {
              return n.isValidJavaScriptVariableName(e)
                ? [t, ".", e]
                : [t, "[", JSON.stringify(e), "]"];
            },
            depthedLookup: function (t) {
              return [
                this.aliasable("container.lookup"),
                '(depths, "',
                t,
                '")',
              ];
            },
            compilerInfo: function () {
              var t = a.COMPILER_REVISION;
              return [t, a.REVISION_CHANGES[t]];
            },
            appendToBuffer: function (t, e, i) {
              return (
                s.isArray(t) || (t = [t]),
                (t = this.source.wrap(t, e)),
                this.environment.isSimple
                  ? ["return ", t, ";"]
                  : i
                  ? ["buffer += ", t, ";"]
                  : ((t.appendToBuffer = !0), t)
              );
            },
            initializeBuffer: function () {
              return this.quotedString("");
            },
            compile: function (t, e, i, n) {
              (this.environment = t),
                (this.options = e),
                (this.stringParams = this.options.stringParams),
                (this.trackIds = this.options.trackIds),
                (this.precompile = !n),
                (this.name = this.environment.name),
                (this.isChild = !!i),
                (this.context = i || {
                  decorators: [],
                  programs: [],
                  environments: [],
                }),
                this.preamble(),
                (this.stackSlot = 0),
                (this.stackVars = []),
                (this.aliases = {}),
                (this.registers = { list: [] }),
                (this.hashes = []),
                (this.compileStack = []),
                (this.inlineStack = []),
                (this.blockParams = []),
                this.compileChildren(t, e),
                (this.useDepths =
                  this.useDepths ||
                  t.useDepths ||
                  t.useDecorators ||
                  this.options.compat),
                (this.useBlockParams = this.useBlockParams || t.useBlockParams);
              for (
                var o,
                  a = t.opcodes,
                  s = void 0,
                  r = void 0,
                  c = void 0,
                  r = 0,
                  c = a.length;
                r < c;
                r++
              )
                (o = a[r]),
                  (this.source.currentLocation = o.loc),
                  (s = s || o.loc),
                  this[o.opcode].apply(this, o.args);
              if (
                ((this.source.currentLocation = s),
                this.pushSource(""),
                this.stackSlot ||
                  this.inlineStack.length ||
                  this.compileStack.length)
              )
                throw new h.default(
                  "Compile completed with content left on stack"
                );
              this.decorators.isEmpty()
                ? (this.decorators = void 0)
                : ((this.useDecorators = !0),
                  this.decorators.prepend(
                    "var decorators = container.decorators;\n"
                  ),
                  this.decorators.push("return fn;"),
                  n
                    ? (this.decorators = Function.apply(this, [
                        "fn",
                        "props",
                        "container",
                        "depth0",
                        "data",
                        "blockParams",
                        "depths",
                        this.decorators.merge(),
                      ]))
                    : (this.decorators.prepend(
                        "function(fn, props, container, depth0, data, blockParams, depths) {\n"
                      ),
                      this.decorators.push("}\n"),
                      (this.decorators = this.decorators.merge())));
              i = this.createFunctionContext(n);
              if (this.isChild) return i;
              var p = { compiler: this.compilerInfo(), main: i },
                t =
                  (this.decorators &&
                    ((p.main_d = this.decorators), (p.useDecorators = !0)),
                  this.context),
                l = t.programs,
                u = t.decorators;
              for (r = 0, c = l.length; r < c; r++)
                l[r] &&
                  ((p[r] = l[r]), u[r]) &&
                  ((p[r + "_d"] = u[r]), (p.useDecorators = !0));
              return (
                this.environment.usePartial && (p.usePartial = !0),
                this.options.data && (p.useData = !0),
                this.useDepths && (p.useDepths = !0),
                this.useBlockParams && (p.useBlockParams = !0),
                this.options.compat && (p.compat = !0),
                n
                  ? (p.compilerOptions = this.options)
                  : ((p.compiler = JSON.stringify(p.compiler)),
                    (this.source.currentLocation = {
                      start: { line: 1, column: 0 },
                    }),
                    (p = this.objectLiteral(p)),
                    e.srcName
                      ? ((p = p.toStringWithSourceMap({
                          file: e.destName,
                        })).map = p.map && p.map.toString())
                      : (p = p.toString())),
                p
              );
            },
            preamble: function () {
              (this.lastContext = 0),
                (this.source = new c.default(this.options.srcName)),
                (this.decorators = new c.default(this.options.srcName));
            },
            createFunctionContext: function (t) {
              var e,
                i = "",
                n = this.stackVars.concat(this.registers.list),
                o = (0 < n.length && (i += ", " + n.join(", ")), 0);
              for (e in this.aliases) {
                var a = this.aliases[e];
                this.aliases.hasOwnProperty(e) &&
                  a.children &&
                  1 < a.referenceCount &&
                  ((i += ", alias" + ++o + "=" + e),
                  (a.children[0] = "alias" + o));
              }
              var n = ["container", "depth0", "helpers", "partials", "data"],
                s =
                  ((this.useBlockParams || this.useDepths) &&
                    n.push("blockParams"),
                  this.useDepths && n.push("depths"),
                  this.mergeSource(i));
              return t
                ? (n.push(s), Function.apply(this, n))
                : this.source.wrap([
                    "function(",
                    n.join(","),
                    ") {\n  ",
                    s,
                    "}",
                  ]);
            },
            mergeSource: function (t) {
              var e = this.environment.isSimple,
                i = !this.forceBuffer,
                n = void 0,
                o = void 0,
                a = void 0,
                s = void 0;
              return (
                this.source.each(function (t) {
                  t.appendToBuffer
                    ? (a ? t.prepend("  + ") : (a = t), (s = t))
                    : (a &&
                        (o ? a.prepend("buffer += ") : (n = !0),
                        s.add(";"),
                        (a = s = void 0)),
                      (o = !0),
                      e || (i = !1));
                }),
                i
                  ? a
                    ? (a.prepend("return "), s.add(";"))
                    : o || this.source.push('return "";')
                  : ((t += ", buffer = " + (n ? "" : this.initializeBuffer())),
                    a
                      ? (a.prepend("return buffer + "), s.add(";"))
                      : this.source.push("return buffer;")),
                t &&
                  this.source.prepend(
                    "var " + t.substring(2) + (n ? "" : ";\n")
                  ),
                this.source.merge()
              );
            },
            blockValue: function (t) {
              var e = this.aliasable("helpers.blockHelperMissing"),
                i = [this.contextName(0)],
                t = (this.setupHelperArgs(t, 0, i), this.popStack());
              i.splice(1, 0, t),
                this.push(this.source.functionCall(e, "call", i));
            },
            ambiguousBlockValue: function () {
              var t = this.aliasable("helpers.blockHelperMissing"),
                e = [this.contextName(0)],
                i =
                  (this.setupHelperArgs("", 0, e, !0),
                  this.flushInline(),
                  this.topStack());
              e.splice(1, 0, i),
                this.pushSource([
                  "if (!",
                  this.lastHelper,
                  ") { ",
                  i,
                  " = ",
                  this.source.functionCall(t, "call", e),
                  "}",
                ]);
            },
            appendContent: function (t) {
              this.pendingContent
                ? (t = this.pendingContent + t)
                : (this.pendingLocation = this.source.currentLocation),
                (this.pendingContent = t);
            },
            append: function () {
              var t;
              this.isInline()
                ? (this.replaceStack(function (t) {
                    return [" != null ? ", t, ' : ""'];
                  }),
                  this.pushSource(this.appendToBuffer(this.popStack())))
                : ((t = this.popStack()),
                  this.pushSource([
                    "if (",
                    t,
                    " != null) { ",
                    this.appendToBuffer(t, void 0, !0),
                    " }",
                  ]),
                  this.environment.isSimple &&
                    this.pushSource([
                      "else { ",
                      this.appendToBuffer("''", void 0, !0),
                      " }",
                    ]));
            },
            appendEscaped: function () {
              this.pushSource(
                this.appendToBuffer([
                  this.aliasable("container.escapeExpression"),
                  "(",
                  this.popStack(),
                  ")",
                ])
              );
            },
            getContext: function (t) {
              this.lastContext = t;
            },
            pushContext: function () {
              this.pushStackLiteral(this.contextName(this.lastContext));
            },
            lookupOnContext: function (t, e, i, n) {
              var o = 0;
              n || !this.options.compat || this.lastContext
                ? this.pushContext()
                : this.push(this.depthedLookup(t[o++])),
                this.resolvePath("context", t, o, e, i);
            },
            lookupBlockParam: function (t, e) {
              (this.useBlockParams = !0),
                this.push(["blockParams[", t[0], "][", t[1], "]"]),
                this.resolvePath("context", e, 1);
            },
            lookupData: function (t, e, i) {
              t
                ? this.pushStackLiteral("container.data(data, " + t + ")")
                : this.pushStackLiteral("data"),
                this.resolvePath("data", e, 0, !0, i);
            },
            resolvePath: function (i, n, o, a, t) {
              var s = this;
              if (this.options.strict || this.options.assumeObjects)
                this.push(
                  (function (t, e, i, n) {
                    var o = e.popStack(),
                      a = 0,
                      s = i.length;
                    for (t && s--; a < s; a++) o = e.nameLookup(o, i[a], n);
                    return t
                      ? [
                          e.aliasable("container.strict"),
                          "(",
                          o,
                          ", ",
                          e.quotedString(i[a]),
                          ")",
                        ]
                      : o;
                  })(this.options.strict && t, this, n, i)
                );
              else
                for (var e = n.length; o < e; o++)
                  this.replaceStack(function (t) {
                    var e = s.nameLookup(t, n[o], i);
                    return a ? [" && ", e] : [" != null ? ", e, " : ", t];
                  });
            },
            resolvePossibleLambda: function () {
              this.push([
                this.aliasable("container.lambda"),
                "(",
                this.popStack(),
                ", ",
                this.contextName(0),
                ")",
              ]);
            },
            pushStringParam: function (t, e) {
              this.pushContext(),
                this.pushString(e),
                "SubExpression" !== e &&
                  ("string" == typeof t
                    ? this.pushString(t)
                    : this.pushStackLiteral(t));
            },
            emptyHash: function (t) {
              this.trackIds && this.push("{}"),
                this.stringParams && (this.push("{}"), this.push("{}")),
                this.pushStackLiteral(t ? "undefined" : "{}");
            },
            pushHash: function () {
              this.hash && this.hashes.push(this.hash),
                (this.hash = { values: [], types: [], contexts: [], ids: [] });
            },
            popHash: function () {
              var t = this.hash;
              (this.hash = this.hashes.pop()),
                this.trackIds && this.push(this.objectLiteral(t.ids)),
                this.stringParams &&
                  (this.push(this.objectLiteral(t.contexts)),
                  this.push(this.objectLiteral(t.types))),
                this.push(this.objectLiteral(t.values));
            },
            pushString: function (t) {
              this.pushStackLiteral(this.quotedString(t));
            },
            pushLiteral: function (t) {
              this.pushStackLiteral(t);
            },
            pushProgram: function (t) {
              null != t
                ? this.pushStackLiteral(this.programExpression(t))
                : this.pushStackLiteral(null);
            },
            registerDecorator: function (t, e) {
              var i = this.nameLookup("decorators", e, "decorator"),
                e = this.setupHelperArgs(e, t);
              this.decorators.push([
                "fn = ",
                this.decorators.functionCall(i, "", [
                  "fn",
                  "props",
                  "container",
                  e,
                ]),
                " || fn;",
              ]);
            },
            invokeHelper: function (t, e, i) {
              var n = this.popStack(),
                t = this.setupHelper(t, e),
                e = i ? [t.name, " || "] : "",
                i = ["("].concat(e, n);
              this.options.strict ||
                i.push(" || ", this.aliasable("helpers.helperMissing")),
                i.push(")"),
                this.push(this.source.functionCall(i, "call", t.callParams));
            },
            invokeKnownHelper: function (t, e) {
              t = this.setupHelper(t, e);
              this.push(this.source.functionCall(t.name, "call", t.callParams));
            },
            invokeAmbiguous: function (t, e) {
              this.useRegister("helper");
              var i = this.popStack(),
                e = (this.emptyHash(), this.setupHelper(0, t, e)),
                t = [
                  "(",
                  "(helper = ",
                  (this.lastHelper = this.nameLookup("helpers", t, "helper")),
                  " || ",
                  i,
                  ")",
                ];
              this.options.strict ||
                ((t[0] = "(helper = "),
                t.push(
                  " != null ? helper : ",
                  this.aliasable("helpers.helperMissing")
                )),
                this.push([
                  "(",
                  t,
                  e.paramsInit ? ["),(", e.paramsInit] : [],
                  "),",
                  "(typeof helper === ",
                  this.aliasable('"function"'),
                  " ? ",
                  this.source.functionCall("helper", "call", e.callParams),
                  " : helper))",
                ]);
            },
            invokePartial: function (t, e, i) {
              var n = [],
                o = this.setupParams(e, 1, n);
              t && ((e = this.popStack()), delete o.name),
                i && (o.indent = JSON.stringify(i)),
                (o.helpers = "helpers"),
                (o.partials = "partials"),
                (o.decorators = "container.decorators"),
                t
                  ? n.unshift(e)
                  : n.unshift(this.nameLookup("partials", e, "partial")),
                this.options.compat && (o.depths = "depths"),
                (o = this.objectLiteral(o)),
                n.push(o),
                this.push(
                  this.source.functionCall("container.invokePartial", "", n)
                );
            },
            assignToHash: function (t) {
              var e = this.popStack(),
                i = void 0,
                n = void 0,
                o = void 0,
                a =
                  (this.trackIds && (o = this.popStack()),
                  this.stringParams &&
                    ((n = this.popStack()), (i = this.popStack())),
                  this.hash);
              i && (a.contexts[t] = i),
                n && (a.types[t] = n),
                o && (a.ids[t] = o),
                (a.values[t] = e);
            },
            pushId: function (t, e, i) {
              "BlockParam" === t
                ? this.pushStackLiteral(
                    "blockParams[" +
                      e[0] +
                      "].path[" +
                      e[1] +
                      "]" +
                      (i ? " + " + JSON.stringify("." + i) : "")
                  )
                : "PathExpression" === t
                ? this.pushString(e)
                : "SubExpression" === t
                ? this.pushStackLiteral("true")
                : this.pushStackLiteral("null");
            },
            compiler: n,
            compileChildren: function (t, e) {
              for (
                var i = t.children, n = void 0, o = void 0, a = 0, s = i.length;
                a < s;
                a++
              ) {
                var r,
                  n = i[a],
                  o = new this.compiler(),
                  c = this.matchExistingProgram(n);
                null == c
                  ? (this.context.programs.push(""),
                    (r = this.context.programs.length),
                    (n.index = r),
                    (n.name = "program" + r),
                    (this.context.programs[r] = o.compile(
                      n,
                      e,
                      this.context,
                      !this.precompile
                    )),
                    (this.context.decorators[r] = o.decorators),
                    (this.context.environments[r] = n),
                    (this.useDepths = this.useDepths || o.useDepths),
                    (this.useBlockParams =
                      this.useBlockParams || o.useBlockParams),
                    (n.useDepths = this.useDepths),
                    (n.useBlockParams = this.useBlockParams))
                  : ((n.index = c.index),
                    (n.name = "program" + c.index),
                    (this.useDepths = this.useDepths || c.useDepths),
                    (this.useBlockParams =
                      this.useBlockParams || c.useBlockParams));
              }
            },
            matchExistingProgram: function (t) {
              for (
                var e = 0, i = this.context.environments.length;
                e < i;
                e++
              ) {
                var n = this.context.environments[e];
                if (n && n.equals(t)) return n;
              }
            },
            programExpression: function (t) {
              (t = this.environment.children[t]),
                (t = [t.index, "data", t.blockParams]);
              return (
                (this.useBlockParams || this.useDepths) &&
                  t.push("blockParams"),
                this.useDepths && t.push("depths"),
                "container.program(" + t.join(", ") + ")"
              );
            },
            useRegister: function (t) {
              this.registers[t] ||
                ((this.registers[t] = !0), this.registers.list.push(t));
            },
            push: function (t) {
              return (
                t instanceof r || (t = this.source.wrap(t)),
                this.inlineStack.push(t),
                t
              );
            },
            pushStackLiteral: function (t) {
              this.push(new r(t));
            },
            pushSource: function (t) {
              this.pendingContent &&
                (this.source.push(
                  this.appendToBuffer(
                    this.source.quotedString(this.pendingContent),
                    this.pendingLocation
                  )
                ),
                (this.pendingContent = void 0)),
                t && this.source.push(t);
            },
            replaceStack: function (t) {
              var e = ["("],
                i = void 0,
                n = void 0,
                o = void 0;
              if (!this.isInline())
                throw new h.default("replaceStack on non-inline");
              var a = this.popStack(!0),
                s =
                  (a instanceof r
                    ? ((e = ["(", (i = [a.value])]), (o = !0))
                    : ((n = !0),
                      (s = this.incrStack()),
                      (e = ["((", this.push(s), " = ", a, ")"]),
                      (i = this.topStack())),
                  t.call(this, i));
              o || this.popStack(),
                n && this.stackSlot--,
                this.push(e.concat(s, ")"));
            },
            incrStack: function () {
              return (
                this.stackSlot++,
                this.stackSlot > this.stackVars.length &&
                  this.stackVars.push("stack" + this.stackSlot),
                this.topStackName()
              );
            },
            topStackName: function () {
              return "stack" + this.stackSlot;
            },
            flushInline: function () {
              var t = this.inlineStack;
              this.inlineStack = [];
              for (var e = 0, i = t.length; e < i; e++) {
                var n,
                  o = t[e];
                o instanceof r
                  ? this.compileStack.push(o)
                  : ((n = this.incrStack()),
                    this.pushSource([n, " = ", o, ";"]),
                    this.compileStack.push(n));
              }
            },
            isInline: function () {
              return this.inlineStack.length;
            },
            popStack: function (t) {
              var e = this.isInline(),
                i = (e ? this.inlineStack : this.compileStack).pop();
              if (!t && i instanceof r) return i.value;
              if (!e) {
                if (!this.stackSlot) throw new h.default("Invalid stack pop");
                this.stackSlot--;
              }
              return i;
            },
            topStack: function () {
              var t = this.isInline() ? this.inlineStack : this.compileStack,
                t = t[t.length - 1];
              return t instanceof r ? t.value : t;
            },
            contextName: function (t) {
              return this.useDepths && t ? "depths[" + t + "]" : "depth" + t;
            },
            quotedString: function (t) {
              return this.source.quotedString(t);
            },
            objectLiteral: function (t) {
              return this.source.objectLiteral(t);
            },
            aliasable: function (t) {
              var e = this.aliases[t];
              return (
                e
                  ? e.referenceCount++
                  : (((e = this.aliases[t] = this.source.wrap(t)).aliasable =
                      !0),
                    (e.referenceCount = 1)),
                e
              );
            },
            setupHelper: function (t, e, i) {
              var n = [];
              return {
                params: n,
                paramsInit: this.setupHelperArgs(e, t, n, i),
                name: this.nameLookup("helpers", e, "helper"),
                callParams: [
                  this.aliasable(
                    this.contextName(0) +
                      " != null ? " +
                      this.contextName(0) +
                      " : (container.nullContext || {})"
                  ),
                ].concat(n),
              };
            },
            setupParams: function (t, e, i) {
              var n,
                o = {},
                a = [],
                s = [],
                r = [],
                c = !i,
                t =
                  (c && (i = []),
                  (o.name = this.quotedString(t)),
                  (o.hash = this.popStack()),
                  this.trackIds && (o.hashIds = this.popStack()),
                  this.stringParams &&
                    ((o.hashTypes = this.popStack()),
                    (o.hashContexts = this.popStack())),
                  this.popStack()),
                p = this.popStack();
              (p || t) &&
                ((o.fn = p || "container.noop"),
                (o.inverse = t || "container.noop"));
              for (var l = e; l--; )
                (n = this.popStack()),
                  (i[l] = n),
                  this.trackIds && (r[l] = this.popStack()),
                  this.stringParams &&
                    ((s[l] = this.popStack()), (a[l] = this.popStack()));
              return (
                c && (o.args = this.source.generateArray(i)),
                this.trackIds && (o.ids = this.source.generateArray(r)),
                this.stringParams &&
                  ((o.types = this.source.generateArray(s)),
                  (o.contexts = this.source.generateArray(a))),
                this.options.data && (o.data = "data"),
                this.useBlockParams && (o.blockParams = "blockParams"),
                o
              );
            },
            setupHelperArgs: function (t, e, i, n) {
              (t = this.setupParams(t, e, i)), (t = this.objectLiteral(t));
              return n
                ? (this.useRegister("options"),
                  i.push("options"),
                  ["options=", t])
                : i
                ? (i.push(t), "")
                : t;
            },
          };
          for (
            var p =
                "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                  " "
                ),
              l = (n.RESERVED_WORDS = {}),
              u = 0,
              d = p.length;
            u < d;
            u++
          )
            l[p[u]] = !0;
          (n.isValidJavaScriptVariableName = function (t) {
            return !n.RESERVED_WORDS[t] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(t);
          }),
            (e.default = n),
            (t.exports = e.default);
        },
        function (t, e, i) {
          "use strict";
          function a(t, e, i) {
            if (s.isArray(t)) {
              for (var n = [], o = 0, a = t.length; o < a; o++)
                n.push(e.wrap(t[o], i));
              return n;
            }
            return "boolean" == typeof t || "number" == typeof t ? t + "" : t;
          }
          function n(t) {
            (this.srcFile = t), (this.source = []);
          }
          e.__esModule = !0;
          var s = i(5),
            o = void 0;
          o ||
            ((o = function (t, e, i, n) {
              (this.src = ""), n && this.add(n);
            }).prototype = {
              add: function (t) {
                s.isArray(t) && (t = t.join("")), (this.src += t);
              },
              prepend: function (t) {
                s.isArray(t) && (t = t.join("")), (this.src = t + this.src);
              },
              toStringWithSourceMap: function () {
                return { code: this.toString() };
              },
              toString: function () {
                return this.src;
              },
            }),
            (n.prototype = {
              isEmpty: function () {
                return !this.source.length;
              },
              prepend: function (t, e) {
                this.source.unshift(this.wrap(t, e));
              },
              push: function (t, e) {
                this.source.push(this.wrap(t, e));
              },
              merge: function () {
                var e = this.empty();
                return (
                  this.each(function (t) {
                    e.add(["  ", t, "\n"]);
                  }),
                  e
                );
              },
              each: function (t) {
                for (var e = 0, i = this.source.length; e < i; e++)
                  t(this.source[e]);
              },
              empty: function () {
                var t = this.currentLocation || { start: {} };
                return new o(t.start.line, t.start.column, this.srcFile);
              },
              wrap: function (t) {
                var e =
                  arguments.length <= 1 || void 0 === arguments[1]
                    ? this.currentLocation || { start: {} }
                    : arguments[1];
                return t instanceof o
                  ? t
                  : ((t = a(t, this, e)),
                    new o(e.start.line, e.start.column, this.srcFile, t));
              },
              functionCall: function (t, e, i) {
                return (
                  (i = this.generateList(i)),
                  this.wrap([t, e ? "." + e + "(" : "(", i, ")"])
                );
              },
              quotedString: function (t) {
                return (
                  '"' +
                  (t + "")
                    .replace(/\\/g, "\\\\")
                    .replace(/"/g, '\\"')
                    .replace(/\n/g, "\\n")
                    .replace(/\r/g, "\\r")
                    .replace(/\u2028/g, "\\u2028")
                    .replace(/\u2029/g, "\\u2029") +
                  '"'
                );
              },
              objectLiteral: function (t) {
                var e,
                  i,
                  n = [];
                for (e in t)
                  t.hasOwnProperty(e) &&
                    "undefined" !== (i = a(t[e], this)) &&
                    n.push([this.quotedString(e), ":", i]);
                var o = this.generateList(n);
                return o.prepend("{"), o.add("}"), o;
              },
              generateList: function (t) {
                for (var e = this.empty(), i = 0, n = t.length; i < n; i++)
                  i && e.add(","), e.add(a(t[i], this));
                return e;
              },
              generateArray: function (t) {
                t = this.generateList(t);
                return t.prepend("["), t.add("]"), t;
              },
            }),
            (e.default = n),
            (t.exports = e.default);
        },
      ]),
      (o = {}),
      (i.m = n),
      (i.c = o),
      (i.p = ""),
      i(0)
    );
    function i(t) {
      var e;
      return (
        o[t] ||
        ((e = o[t] = { exports: {}, id: t, loaded: !1 }),
        n[t].call(e.exports, e, e.exports, i),
        (e.loaded = !0),
        e)
      ).exports;
    }
    var n, o;
  }),
  (window.appikonDiscount.isAppikonProductPage =
    null !=
    decodeURIComponent(window.location.pathname).match(
      /\/products\/(([a-zA-Z0-9]|[\-\.\_\~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\ud83c\ud83d\ud83e][\ud000-\udfff]){1,})\/?/
    )),
  (window.appikonDiscount.isAppikonCartPage =
    "/cart" === window.location.pathname),
  (window.appikonDiscount.reloadCurrency = () => {
    "object" == typeof Currency &&
      "object" == typeof Currency.moneyFormats &&
      "function" == typeof mlvedaload &&
      mlvedaload(),
      "undefined" != typeof ACSCurrency &&
        void 0 !== ACSCurrency.moneyFormats &&
        mlvedaload();
    try {
      "object" == typeof DoublyGlobalCurrency &&
        "function" == typeof DoublyGlobalCurrency.convertAll &&
        DoublyGlobalCurrency.convertAll(
          jQueryGrizzly("[name=doubly-currencies]").val()
        );
    } catch (t) {
      console.log(t);
    }
  }),
  (window.appikonDiscount.checkTermsAccepted = (e) => {
    if (!window.appikonDiscount.settings.turn_off_agree_checkbox)
      if (window.appikonDiscount.settings.terms_selector) {
        var i = window.appikonDiscount.settings.terms_selector.split(",");
        for (let t = 0; t < i.length; t++) {
          var n = "input[type='checkbox']" + i[t],
            o = "input[type='checkbox']" + i[t] + ":checked";
          if (0 < e(n).length && 0 === e(o).length) return !1;
        }
      } else if (
        0 < e("input[type='checkbox']#agree").length &&
        0 === e("input[type='checkbox']#agree:checked").length
      )
        return !1;
    return !0;
  }),
  (window.appikonDiscount.DiscountedPricingCheckout = (i, t) => {
    var e, n;
    window.appikonDiscount.checkTermsAccepted(i)
      ? (window.appikonDiscount.log("terms accepted!"),
        i(t.target).prop("disabled", "disabled"),
        (window.appikon.action_type = "checkout"),
        (e = []),
        (n = []),
        i("[name^='attributes']").each(function () {
          var t = i(this),
            e = {
              name: i(this)
                .attr("name")
                .replace(/^attributes\[/i, "")
                .replace(/\]$/i, ""),
              value: t.val(),
            };
          "" == e.value ||
            ("input" === t[0].tagName.toLowerCase() &&
              "checkbox" == t.attr("type") &&
              !t.is(":checked")) ||
            n.push(e);
        }),
        (t = ""),
        window.Shopify.locale && e.push("locale=" + window.Shopify.locale),
        i("[name='note']").length && (t = i("[name='note']")[0].value),
        (window.appikon.cart.note_attributes = n),
        (window.appikon.cart.note = t).length &&
          e.push("note=" + encodeURIComponent(t)),
        n.length &&
          n.map(function (t) {
            e.push(
              "attributes" +
                encodeURIComponent("[" + t.name + "]") +
                "=" +
                encodeURIComponent(t.value)
            );
          }),
        i.ajax({
          cache: !1,
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          type: "POST",
          url: window.appikonDiscount.settings.app_root_url,
          data: JSON.stringify(window.appikon),
          success: function (t) {
            t.invoice_url
              ? (e.length && (t.invoice_url += "?" + e.join("&")),
                setTimeout(function () {
                  window.location.href = t.invoice_url;
                }, window
                  .appikonDiscount.settings.draft_order_invoice_load_delay))
              : ((t.invoice_url = "/checkout"),
                t.discount_code &&
                  (window.appikonDiscount.setCookie("adp-pr-id", t.pr_id, 14),
                  e.push("discount=" + t.discount_code)),
                e.length && (t.invoice_url += "?" + e.join("&")),
                (window.location.href = t.invoice_url));
          },
          error: function (t) {
            console.log(t), (window.location.href = "/checkout");
          },
        }))
      : window.appikonDiscount.log("terms not accepted!");
  }),
  (window.appikonDiscount.checkoutEventHandler = (t, e) => {
    window.appikonDiscount.log("checkout handler triggered"),
      e.preventDefault();
    try {
      e.stopImmediatePropagation(),
        window.appikonDiscount.DiscountedPricingCheckout(t, e);
    } catch (t) {
      window.appikonDiscount.log(
        "error occured in checkout handler...sending to regular checkout."
      ),
        console.error(t),
        (window.location = "/checkout");
    }
  }),
  (window.appikonDiscount.addGlobalStyle = (t) => {
    try {
      var e = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
      (i.innerHTML = t), (i.type = "text/css"), e.appendChild(i);
    } catch (t) {}
  }),
  (window.appikonDiscount.addCheckoutEventHandlers = (e) => {
    var t = window.appikonDiscount.getCheckoutSelectors();
    window.appikonDiscount.checkoutClickListener
      ? window.appikonDiscount.log("checkout click handler already exists")
      : (window.appikonDiscount.log("creating checkout click handler"),
        (window.appikonDiscount.checkoutClickListener = (t) =>
          window.appikonDiscount.checkoutEventHandler(e, t))),
      t.forEach(function (t) {
        var e = document.querySelectorAll(t);
        if ("object" == typeof e && e)
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            if ("function" != typeof n.addEventListener) return;
            window.appikonDiscount.log(
              "adding click handler to found element: " + t
            ),
              n.addEventListener(
                "click",
                window.appikonDiscount.checkoutClickListener,
                !1
              );
          }
      });
  }),
  (window.appikonDiscount.removeCheckoutEventHandlers = (t) => {
    window.appikonDiscount.getCheckoutSelectors().forEach(function (t) {
      var e = document.querySelectorAll(t);
      if ("object" == typeof e && e)
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          if ("function" != typeof n.addEventListener) return;
          window.appikonDiscount.checkoutClickListener &&
            n.removeEventListener(
              "click",
              window.appikonDiscount.checkoutClickListener,
              !1
            );
        }
    });
  }),
  (window.appikonDiscount.showCartDiscounts = (t, e) => {
    if (
      ((window.appikon.discounts = e),
      window.appikonDiscount.updateCartItems(t, e.cart.items),
      "string" == typeof e.discounted_price_html)
    ) {
      if (
        (window.appikonDiscount.settings.hide_paypal &&
          (t(
            ".additional_checkout_buttons,.additional-checkout-button,.additional-checkout-buttons, .extra-checkout-buttons, .dynamic-checkout__content,.cart__additional_checkout, .cart-checkout-additional, #dynamic-checkout-cart"
          ).hide(),
          window.appikonDiscount.addGlobalStyle(
            ".additional_checkout_buttons, .additional-checkout-button, .additional-checkout-buttons  {display:none !important;}"
          )),
        e.positive_discount && window.appikonDiscount.displayCartTotals(t, e),
        e.zero_discount_only || 0 == window.appikon.cart.total_price)
      ) {
        t('form[action*="/cart"]').append(
          "<input type='hidden' value='1' name='attributes[adp_identifier]'>"
        );
        try {
          window.appikon.cart.attributes.adp_identifier = 1;
        } catch (t) {}
        window.appikonDiscount.removeCheckoutEventHandlers(t);
      } else window.appikonDiscount.addCheckoutEventHandlers(t);
      t(".wholesale-cart-total").css("font-weight", "bold");
    } else
      !0 === window.appikonDiscount.settings.use_compare_at_price
        ? window.appikonDiscount.displayCartTotals(t, e)
        : t(".wholesale-cart-total").html(
            "<span class=''>" + e.original_price_html + "</span>"
          ),
        t("span.wholesale-original-cart-total").css("display", "none"),
        t(".wholesale-cart-total").css("font-weight", "normal"),
        window.appikonDiscount.removeCheckoutEventHandlers(t);
  }),
  (window.appikonDiscount.showAppikonNotificatioBar = (e, t, i, n) => {
    var o;
    t &&
      t.trim() &&
      ((o =
        "<div id='appikon-notification-bar'><div id='appikon-close-notification'>X</div>" +
        t.trim() +
        "</div>"),
      e("#appikon-notification-bar").remove(),
      i
        ? (t = e(i).first()).length &&
          ("before" == n.toLowerCase() ? t.before(o) : t.after(o))
        : window.appikonDiscount.settings.global.headerSelector
            .split(",")
            .forEach(function (t) {
              "#shopify-section-header" == (t = e.trim(t))
                ? e(t).after(o)
                : "main" == t
                ? e(t).prepend(o)
                : e(t).before(o);
            }),
      0 < e("#appikon-notification-bar").length) &&
      e("#appikon-notification-bar").show();
  }),
  (window.appikonDiscount.showAppikonNotification = (t, e) => {
    window.appikonDiscount.isAppikonProductPage &&
      window.appikonDiscount.settings.show_product_notification_bar &&
      window.appikonDiscount.showAppikonNotificatioBar(
        t,
        e,
        window.appikonDiscount.settings.notification_placement_settings
          .final_selector,
        window.appikonDiscount.settings.notification_placement_settings
          .placement
      ),
      window.appikonDiscount.isAppikonCartPage &&
        window.appikonDiscount.settings.show_cart_notification_bar &&
        window.appikonDiscount.showAppikonNotificatioBar(
          t,
          e,
          window.appikonDiscount.settings.notification_cart_placement_settings
            .final_selector,
          window.appikonDiscount.settings.notification_cart_placement_settings
            .placement
        );
  }),
  (window.appikonDiscount.showVolDiscounts = (t, e) => {
    var i, n;
    e.discount_table &&
      e.discount_table.automatic_type &&
      ((i = {
        product_message:
          e.offer_product_message ||
          window.appikonDiscount.settings.dp.vd_product_message,
        vol_rows: e.vol_rows,
      }),
      "DEFAULT" === e.discount_table.automatic_type
        ? (n = t("#adp-discount-tiers-default").html())
        : "DETAILED" === e.discount_table.automatic_type
        ? (n = t("#adp-discount-tiers-detailed").html())
        : "GRID_RANGE" === e.discount_table.automatic_type
        ? (n = t("#adp-discount-tiers-grid").html())
        : "GRID_RANGE_ALT" === e.discount_table.automatic_type &&
          (n = t("#adp-discount-tiers-grid-alt").html()),
      (e = appikonHandlebars.compile(n)(i)),
      t("div.adp-vol-wrapper").html(e));
  }),
  (window.appikonDiscount.showBuyXDiscounts = (t, e) => {
    var i = t("#adp-buy-x-discount-tiers").html(),
      e = {
        product_message:
          e.offer_product_message ||
          window.appikonDiscount.settings.dp.vd_product_message,
        vol_rows: e.vol_rows,
      },
      i = appikonHandlebars.compile(i)(e);
    t("div.adp-vol-wrapper").html(i);
  }),
  (window.appikonDiscount.appikonDelegate = (e, i) => {
    if (
      (i.vol_rows && (window.appikon.vol_rows = i.vol_rows),
      i.discount_table &&
        "CUSTOM" === i.discount_table.type &&
        i.discount_table.html)
    ) {
      e(".adp-vol-wrapper").remove();
      var n = [];
      let t = !1;
      var o = e(".shopacado-discount-table-container");
      if (
        (0 < o.length && ((t = !0), n.push(o)),
        i.discount_table.placement_selector)
      ) {
        var a = e(i.discount_table.placement_selector);
        if (0 < a.length) {
          t = !0;
          for (var s = 0; s < a.length; s++) {
            var r = a.eq(s);
            n.push(r);
          }
        }
      }
      t || ((o = e("form[action*='/cart/add']").first()), n.push(o));
      for (let t = 0; t < n.length; t++) {
        var c = n[t],
          p = "<div class='adp-vol-wrapper'></div>";
        "BEFORE" == i.discount_table.placement_position
          ? c.before(p)
          : c.after(p);
      }
      e("div.adp-vol-wrapper").html(i.discount_table.html);
    } else {
      var t;
      i.discount_table &&
        "AUTOMATIC" === i.discount_table.type &&
        (e(".adp-vol-wrapper").remove(), i.vol_rows) &&
        0 < i.vol_rows.length &&
        ("buy_x_dollars" == i.type || "vd" == i.type) &&
        ((window.appikonDiscount.settings.vd_placement_settings.hasOwnProperty(
          "final_selector"
        ) &&
          0 !==
            (t = e(
              window.appikonDiscount.settings.vd_placement_settings
                .final_selector
            ).first()).length) ||
          (t = e("form[action*='/cart/add']").first()),
        0 === e(".adp-vol-wrapper").length &&
          (window.appikonDiscount.settings.vd_placement_settings.hasOwnProperty(
            "placement"
          ) &&
          "before" ==
            window.appikonDiscount.settings.vd_placement_settings.placement
            ? t.before("<div class='adp-vol-wrapper'></div>")
            : t.after("<div class='adp-vol-wrapper'></div>")),
        "buy_x_dollars" === i.type
          ? window.appikonDiscount.showBuyXDiscounts(e, i)
          : window.appikonDiscount.showVolDiscounts(e, i));
    }
    function l(t) {
      return "object" == typeof t ? t : null;
    }
    if (
      (l(i.discounts) &&
        (window.appikonDiscount.isAppikonProductPage && i.product_notification
          ? window.appikonDiscount.showAppikonNotification(
              e,
              i.product_notification
            )
          : window.appikonDiscount.isAppikonCartPage &&
            i.notifications &&
            i.notifications.length &&
            window.appikonDiscount.showAppikonNotification(
              e,
              i.notifications[0]
            ),
        l(i.discounts.cart)) &&
        l(i.discounts.cart.items) &&
        window.appikonDiscount.showCartDiscounts(e, i.discounts),
      i.product_lowest_price_message &&
        window.appikonDiscount.settings.product_page_price_selector &&
        "" !== window.appikonDiscount.settings.product_page_price_selector &&
        ((window.appikonDiscount.productLowestPriceMessage =
          i.product_lowest_price_message),
        e(window.appikonDiscount.settings.product_page_price_selector).html(
          "<span>" + i.product_lowest_price_message + "</span>"
        )),
      window.appikonDiscount.reloadCurrency(),
      document.dispatchEvent(
        new CustomEvent("shopacado:discounts:update", {
          bubbles: !0,
          detail: { discountResponse: i },
        })
      ),
      window.appikonDiscount.postDiscountHandlers)
    )
      for (
        let t = 0;
        t < window.appikonDiscount.postDiscountHandlers.length;
        t++
      )
        window.appikonDiscount.postDiscountHandlers[t](i);
  }),
  (window.appikonDiscount.isCartChange = (t, i) => {
    var n = !1,
      o = window.appikonResponseStore.cartJS;
    return (
      t.each(
        [
          "original_total_price",
          "total_discount",
          "total_weight",
          "item_count",
          "items_subtotal_price",
        ],
        function (t, e) {
          if (o[e] !== i[e]) return !(n = !0);
        }
      ),
      (n = n || o.items.length === i.items.length ? n : !0) ||
        t.each(o.items, function (t, e) {
          t = i.items[t];
          if (e.id !== t.id || e.quantity !== t.quantity) return !(n = !0);
        }),
      n
    );
  }),
  (window.appikonDiscount.processCartData = (t, e) => {
    window.appikonDiscount.isCartChange(t, e)
      ? ((window.appikonResponseStore.cartJS = e),
        window.appikonDiscount.prepareAppikonDiscountRequestData(t, e))
      : window.appikonDiscount.fillCartData(t, !1);
  }),
  (window.appikonDiscount.addCompareAtPrice = async (t, e) => {
    var n = 0;
    return (
      await Promise.all(
        e.items.map(async (i) => {
          t.ajax({
            url: "/products/" + i.handle + ".js",
            dataType: "json",
            async: !1,
            success: function (t) {
              for (const e of t.variants)
                if (
                  ((i.compare_at_price = i.price),
                  e.id == i.variant_id && null != e.compare_at_price)
                ) {
                  i.compare_at_price = e.compare_at_price;
                  break;
                }
              t = i.compare_at_price * i.quantity;
              (n += t), (i.compare_at_line_price = t);
            },
          });
        })
      ),
      (e.compare_at_total_price = n),
      e
    );
  }),
  (window.appikonDiscount.insertCartTitleSnippet = (n, t) => {
    var o = !1;
    return (
      t &&
        ((t = t.split(",")),
        n.each(t, function (t, e) {
          var i,
            e = n(e);
          e.length &&
            ((i = window.appikon.cart),
            e.each(function (t) {
              t < i.items.length &&
                0 === n(this).find(".appikon-cart-item-success-notes").length &&
                (n(this).html(
                  n(this).html() +
                    "<span class='appikon-cart-item-success-notes' data-key='" +
                    i.items[t].key +
                    "'></span><span class='appikon-cart-item-upsell-notes' data-key='" +
                    i.items[t].key +
                    "'></span>"
                ),
                (o = !0));
            }));
        })),
      o
    );
  }),
  (window.appikonDiscount.insertCartLinePriceSnippet = (n, t) => {
    var o = !1;
    return (
      t &&
        ((t = t.split(",")),
        n.each(t, function (t, e) {
          var i,
            e = n(e);
          e.length &&
            ((i = window.appikon.cart),
            e.each(function (t) {
              t < i.items.length &&
                0 == n(this).find(".appikon-cart-item-line-price").length &&
                (n(this).html(
                  "<span class='appikon-cart-item-line-price' data-key='" +
                    i.items[t].key +
                    "'>" +
                    n(this).html() +
                    "</span>"
                ),
                (o = !0));
            }));
        })),
      o
    );
  }),
  (window.appikonDiscount.insertCartUnitPriceSnippet = (n, t) => {
    return (
      t &&
        ((t = t.split(",")),
        n.each(t, function (t, e) {
          var i,
            e = n(e);
          e.length &&
            ((i = window.appikon.cart),
            e.each(function (t) {
              t < i.items.length &&
                0 == n(this).find(".appikon-cart-item-unit-price").length &&
                n(this).html(
                  "<span class='appikon-cart-item-unit-price' data-key='" +
                    i.items[t].key +
                    "'>" +
                    n(this).html() +
                    "</span>"
                );
            }));
        })),
      !1
    );
  }),
  (window.appikonDiscount.insertCartSubTotalSnippet = (i, t) => {
    var n = !1;
    return (
      t &&
        ((t = t.split(",")),
        i.each(t, function (t, e) {
          e = i(e).eq(0);
          e &&
            e.length &&
            0 == e.find(".wholesale-original-cart-total").length &&
            (e.html(
              "<span class='wholesale-original-cart-total'><span class='wholesale-original-price'>" +
                e.html() +
                "</span></span><span class='wholesale-cart-total'></span><div class='additional-notes'><span class='wholesale-minimums-note'></span><span class='wholesale-extra-note'></span></div>"
            ),
            (n = !0));
        })),
      n
    );
  }),
  (window.appikonDiscount.insertCartSnippets = (t, e) => {
    var i = null,
      n = null,
      o = null,
      a = null;
    return (
      "DRAWER" === e
        ? ((i = window.appikonDiscount.insertCartTitleSnippet(
            t,
            window.appikonDiscount.settings.drawer_cart_product_title_selector
          )),
          (n = window.appikonDiscount.insertCartLinePriceSnippet(
            t,
            window.appikonDiscount.settings.drawer_cart_line_price_selector
          )),
          (a = window.appikonDiscount.insertCartUnitPriceSnippet(
            t,
            window.appikonDiscount.settings.drawer_cart_unit_price_selector
          )),
          (o = window.appikonDiscount.insertCartSubTotalSnippet(
            t,
            window.appikonDiscount.settings.drawer_cart_sub_total_selector
          )))
        : "REGULAR" === e &&
          ((i = window.appikonDiscount.insertCartTitleSnippet(
            t,
            window.appikonDiscount.settings.regular_cart_product_title_selector
          )),
          (n = window.appikonDiscount.insertCartLinePriceSnippet(
            t,
            window.appikonDiscount.settings.regular_cart_line_price_selector
          )),
          (a = window.appikonDiscount.insertCartUnitPriceSnippet(
            t,
            window.appikonDiscount.settings.regular_cart_unit_price_selector
          )),
          (o = window.appikonDiscount.insertCartSubTotalSnippet(
            t,
            window.appikonDiscount.settings.regular_cart_sub_total_selector
          ))),
      i || n || o || a
    );
  }),
  (window.appikonDiscount.fillCartData = (i, n) => {
    setTimeout(function () {
      var t, e;
      window.appikonResponseStore.discountResponse &&
        ((t = window.appikonDiscount.insertCartSnippets(i, "DRAWER")),
        (e = !1),
        window.appikonDiscount.settings.is_dynamic_insertion &&
          (e = window.appikonDiscount.insertCartSnippets(i, "REGULAR")),
        t || e || 1 == n) &&
        window.appikonDiscount.appikonDelegate(
          i,
          window.appikonResponseStore.discountResponse
        );
    }, 400);
  }),
  (window.appikonDiscount.enableCheckoutButtons = (i) => {
    var t = window.appikonDiscount.getCheckoutSelectors();
    i.each(t, function (t, e) {
      i(e).prop("disabled", !1);
    });
  }),
  (window.appikonDiscount.disableCheckoutButtons = (i) => {
    var t = window.appikonDiscount.getCheckoutSelectors();
    i.each(t, function (t, e) {
      i(e).prop("disabled", !0);
    });
  }),
  (window.appikonDiscount.getCheckoutSelectors = () => {
    var e =
      window.appikonDiscount.settings.global.appikonCheckoutSelector.split(",");
    return (
      window.appikonDiscount.settings.checkout_selector &&
        window.appikonDiscount.settings.checkout_selector
          .split(",")
          .forEach(function (t) {
            e.push(t.trim());
          }),
      e
    );
  }),
  (window.appikonDiscount.getAppikonDiscountData = (e) => {
    !0 === window.appikonDiscount.settings.use_compare_at_price
      ? e
          .ajax({ cache: !1, type: "GET", url: "/cart.js", dataType: "json" })
          .done(async function (t) {
            t = await window.appikonDiscount.addCompareAtPrice(e, t);
            window.appikonDiscount.processCartData(e, t);
          })
          .fail(function (t, e, i) {
            console.error("getAppikonDiscountData", i, t.responseText);
          })
      : e
          .ajax({ cache: !1, type: "GET", url: "/cart.js", dataType: "json" })
          .done(function (t) {
            window.appikonDiscount.processCartData(e, t);
          })
          .fail(function (t, e, i) {
            console.error("getAppikonDiscountData", i, t.responseText);
          });
  }),
  (window.appikonDiscount.prepareAppikonDiscountRequestData = (n, t) => {
    (window.appikon.cart = t),
      (window.appikon.adp_page = "cart"),
      (window.appikon.discounts = {}),
      (window.appikon.cart_product_ids = []),
      t.items.forEach(function (t) {
        var e = t;
        [
          "product_title",
          "total_discount",
          "discounts",
          "grams",
          "vendor",
          "taxable",
          "gift_card",
          "url",
          "image",
          "featured_image",
          "requires_shipping",
          "product_type",
          "product_description",
          "variant_title",
          "variant_options",
        ].map(function (t) {
          delete e[t];
        }),
          window.appikon.cart_product_ids.push(e.product_id);
      }),
      0 < window.appikon.cart.items.length &&
        n
          .ajax({
            cache: !1,
            type: "GET",
            url: "/cart?view=appikon.json",
            dataType: "text",
            beforeSend: function (t) {
              t.setRequestHeader("x-requested-with", "");
            },
          })
          .done(function (t) {
            var i = JSON.parse(t);
            (window.appikon.cart_collection_ids = []),
              window.appikon.cart.items.forEach(function (e) {
                i.items.forEach(function (t) {
                  t.id == e.id && (e.collection_ids = t.collectionIds);
                }),
                  window.appikon.cart_collection_ids.push(e.collection_ids);
              }),
              window.appikonDiscount.disableCheckoutButtons(n),
              n
                .ajax({
                  cache: !1,
                  type: "POST",
                  url: window.appikonDiscount.settings.app_root_url,
                  data: JSON.stringify(window.appikon),
                  dataType: "json",
                  contentType: "application/json; charset=utf-8",
                })
                .done(function (t) {
                  console.log(
                    "==========>1",
                    t,
                    "==============>1"
                  )((window.appikonResponseStore.discountResponse = t)),
                    window.appikonDiscount.fillCartData(n, !0),
                    window.appikonDiscount.enableCheckoutButtons(n);
                })
                .fail(function (t, e, i) {
                  console.log(e);
                  // console.error("calculateAppikonDiscount", i, t.responseText),
                  window.appikonDiscount.enableCheckoutButtons(n);
                });
          })
          .fail(function (t, e, i) {
            console.error(
              "prepareAppikonDiscountRequestData",
              i,
              t.responseText
            );
          });
  }),
  (window.appikonDiscount.triggerDiscountCalculation = (t) => {
    window.appikonDiscount.log("triggering discount calculation..."),
      window.appikonResponseStore.cartJS
        ? window.appikonDiscount.prepareAppikonDiscountRequestData(
            t,
            window.appikonResponseStore.cartJS
          )
        : window.appikonDiscount.getAppikonDiscountData(t);
  }),
  (window.appikonDiscount.updateCartItems = (t, e) => {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      console.log(n);
      (n.upsell_note = n.upsell_note || ""),
        (n.success_note = n.success_note || ""),
        !0 === window.appikonDiscount.settings.use_compare_at_price
          ? n.discounted_price < n.compare_at_price
            ? (t(".appikon-cart-item-price[data-key='" + n.key + "']").html(
                "<span class='original_price '>" +
                  n.toString() +
                  "</span><span class='discounted_price '>" +
                  n.discounted_price_format +
                  "</span>"
              ),
              t(".appikon-cart-item-line-price[data-key='" + n.key + "']").html(
                "<span class='original_price '>" +
                  n.toString() +
                  "</span><span class='discounted_price '>" +
                  n.discounted_line_price_format +
                  "</span>"
              ),
              t(".appikon-cart-item-unit-price[data-key='" + n.key + "']").html(
                "<span class='original_price '>" +
                  n.toString() +
                  "</span><span class='discounted_price '>" +
                  n.discounted_price_format +
                  "</span>"
              ))
            : (t(".appikon-cart-item-price[data-key='" + n.key + "']").html(
                "<span class='discounted_price appkion_original_price'>" +
                  n.compare_at_price_format +
                  "</span>"
              ),
              t(".appikon-cart-item-line-price[data-key='" + n.key + "']").html(
                "<span class='discounted_price appkion_original_price'>" +
                  n.compare_at_line_price_format +
                  "</span>"
              ),
              t(".appikon-cart-item-unit-price[data-key='" + n.key + "']").html(
                "<span class='discounted_price appkion_original_price'>" +
                  n.compare_at_price_format +
                  "</span>"
              ))
          : n.discounted_price < n.original_price
          ? (t(".appikon-cart-item-price[data-key='" + n.key + "']").html(
              "<span class='original_price '>" +
                n.original_price_format +
                "</span><span class='discounted_price '>" +
                n.discounted_price_format +
                "</span>"
            ),
            t(".appikon-cart-item-line-price[data-key='" + n.key + "']").html(
              "<span class='original_price '>" +
                n.original_line_price_format +
                "</span><span class='discounted_price '>" +
                n.discounted_line_price_format +
                "</span>"
            ),
            t(".appikon-cart-item-unit-price[data-key='" + n.key + "']").html(
              "<span class='original_price '>" +
                n.original_price_format +
                "</span><span class='discounted_price '>" +
                n.discounted_price_format +
                "</span>"
            ))
          : (t(".appikon-cart-item-price[data-key='" + n.key + "']").html(
              "<span class='discounted_price appkion_original_price'>" +
                n.original_price_format +
                "</span>"
            ),
            t(".appikon-cart-item-line-price[data-key='" + n.key + "']").html(
              "<span class='discounted_price appkion_original_price'>" +
                n.original_line_price_format +
                "</span>"
            ),
            t(".appikon-cart-item-unit-price[data-key='" + n.key + "']").html(
              "<span class='discounted_price appkion_original_price'>" +
                n.original_price_format +
                "</span>"
            )),
        t(".appikon-cart-item-upsell-notes[data-key='" + n.key + "']").html(
          n.upsell_note
        ),
        t(".appikon-cart-item-success-notes[data-key='" + n.key + "']").html(
          n.success_note
        );
    }
  }),
  (window.appikonDiscount.displayCartTotals = (n, t) => {
    (0 <
    n(".wholesale-original-cart-total span.wholesale-original-price").length
      ? n(".wholesale-original-cart-total span.wholesale-original-price")
      : n(".wholesale-original-cart-total")
    ).css("text-decoration", "line-through"),
      n(".wholesale-original-cart-total").show(),
      !0 === window.appikonDiscount.settings.use_compare_at_price
        ? n("span.wholesale-original-price").html(t.compare_at_price_html)
        : n("span.wholesale-original-price").html(t.original_price_html),
      t.discounted_price_html
        ? n(".wholesale-cart-total").html(
            "<span class=''>" + t.discounted_price_html + "</span>"
          )
        : n(".wholesale-cart-total").html(
            "<span class=''>" + t.original_price_html + "</span>"
          );
    var e = "";
    t.summary_item_html && (e = t.summary_item_html),
      n(".subtotal .cart_savings.sale").hide(),
      n(".wholesale-cart-total").prepend(
        "<span class='appikon-messages'><div id='appikon-summary-item'>" +
          e +
          "</div><div id='appikon-discount-item'></div></span>"
      ),
      window.appikonDiscount.settings.show_discount_code &&
        0 < t.total_discount &&
        (n(".appikon-discounts-wrapper").remove(),
        window.appikonDiscount.settings.discount_code_settings.inputPlacementSelector
          .split(",")
          .forEach((t, e, i) => {
            (e = "appikon-discount-code-" + e),
              (e =
                "<div class='appikon-discounts-wrapper'><input type='text' id='" +
                e +
                "' placeholder='Discount Code'><button id='apply-appikon-discount' data-identifier='" +
                e +
                "' class='btn btn--secondary'>Apply</button></div>");
            "BEFORE" ===
            window.appikonDiscount.settings.discount_code_settings
              .inputPlacementPosition
              ? n(t).before(e)
              : "AFTER" ===
                window.appikonDiscount.settings.discount_code_settings
                  .inputPlacementPosition
              ? n(t).after(e)
              : "PREPEND" ===
                window.appikonDiscount.settings.discount_code_settings
                  .inputPlacementPosition
              ? n(t).prepend(e)
              : "APPEND" ===
                window.appikonDiscount.settings.discount_code_settings
                  .inputPlacementPosition
              ? n(t).append(e)
              : "REPLACE" ===
                  window.appikonDiscount.settings.discount_code_settings
                    .inputPlacementPosition && (n(t).after(e), n(t).hide());
          }),
        window.appikon.discount_code
          ? (n(".appikon-discounts-wrapper").hide(),
            n("div[id=appikon-discount-item]").html(
              '<button id="appikon-remove-discount-code" type="button">X</button>' +
                t.discount_item_html
            ),
            document
              .querySelectorAll("#appikon-remove-discount-code")
              .forEach((t) => {
                t.addEventListener("click", (t) => {
                  window.appikonDiscount.deleteCookie(
                    "appikon_discount_" + window.appikonDiscount.settings.shop
                  ),
                    delete window.appikon.discount_code,
                    window.appikonDiscount.triggerDiscountCalculation(n);
                });
              }))
          : n(".appikon-discounts-wrapper").show()),
      n(".wholesale-cart-total span").css("text-decoration", "none"),
      window.appikonDiscount.reloadCurrency();
  }),
  (window.appikonDiscount.deleteCookie = (t) => {
    var e = new Date(),
      e = (e.setTime(e.getTime() - 1e3), "expires=" + e.toUTCString());
    document.cookie = t + "=; " + e + "; path=/;";
  }),
  (window.appikonDiscount.setCookie = (t, e, i) => {
    var n = new Date(),
      i =
        (n.setTime(n.getTime() + 24 * i * 60 * 60 * 1e3),
        "expires=" + n.toUTCString());
    document.cookie = t + "=" + e + "; " + i + "; path=/;";
  }),
  (window.appikonDiscount.setCookieMinutes = (t, e, i) => {
    var n = new Date(),
      i = (n.setTime(n.getTime() + 6e4 * i), "expires=" + n.toUTCString());
    document.cookie = t + "=" + e + "; " + i + "; path=/;";
  }),
  (window.appikonDiscount.setCookieSession = (t, e) => {
    document.cookie = t + "=" + e + "; path=/;";
  }),
  (window.appikonDiscount.getCookie = (t) => {
    for (
      var e = t + "=", i = document.cookie.split(";"), n = 0;
      n < i.length;
      n++
    ) {
      for (var o = i[n]; " " == o.charAt(0); ) o = o.substring(1);
      if (0 == o.indexOf(e)) return o.substring(e.length, o.length);
    }
    return "";
  }),
  (window.appikonDiscount.log = (t) => {
    window.appikonDiscount.settings.debug &&
      console.log("SHOPACADO DEBUG: " + t);
  }),
  (window.appikonDiscount.postDiscountHandlers = []),
  window.appikonDiscount.postDiscountHandlers.push((t) => {
    console.log(t);
  });
const testOfferParam = getUrlParam("shopacadoTestToken"),
  testOfferName = getUrlParam("shopacadoTestName");
!(function (c, p) {
  "use strict";
  var t;
  testOfferParam &&
    (c.appikonDiscount.setCookieSession(
      "shopacado-test-offer-token",
      testOfferParam
    ),
    c.appikonDiscount.setCookieSession(
      "shopacado-test-offer-name",
      testOfferName
    ),
    0 < (t = c.location.toString()).indexOf("?")) &&
    ((t = t.substring(0, t.indexOf("?"))),
    c.history.replaceState({}, p.title, t)),
    -1 !== p.location.search.indexOf("clear_cookies=1") &&
      (c.appikonDiscount.setCookie("adp-skip-ids", ""),
      c.appikonDiscount.setCookie("cart", ""));
  var i = function (o) {
    {
      var t;
      (c.appikon.test_offer_token = c.appikonDiscount.getCookie(
        "shopacado-test-offer-token"
      )),
        (c.appikon.test_offer_name = c.appikonDiscount.getCookie(
          "shopacado-test-offer-name"
        )),
        c.appikon.test_offer_token &&
          "" != c.appikon.test_offer_token &&
          ((t =
            `
                <div id="shopacado-banner">
                    <div id="shopacado-banner-content">
                        Testing Offer: ` +
            c.appikon.test_offer_name +
            `
                        <button id="shopacado-stop-test-offer">Stop Testing</button>
                    </div>
                </div>
            `),
          o("#shopacado-banner").remove(),
          o("body").prepend(t),
          o("body").addClass("push-down"),
          o("#shopacado-stop-test-offer").click(function () {
            o("#shopacado-banner").remove(),
              o("body").removeClass("push-down"),
              c.appikonDiscount.deleteCookie("shopacado-test-offer-token"),
              c.appikonDiscount.deleteCookie("shopacado-test-offer-name"),
              delete c.appikon.test_offer_token,
              delete c.appikon.test_offer_name;
          }));
    }
    function i() {
      var t = (function () {
        let t = !1;
        try {
          (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
            navigator.userAgent
          ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              navigator.userAgent.substr(0, 4)
            )) &&
            (t = !0);
        } catch (t) {}
        return t;
      })()
        ? c.appikonDiscount.settings.delay_mobile_refresh_cart
        : c.appikonDiscount.settings.delay_refresh_cart;
      return 1e3 * parseFloat(t);
    }
    function e() {
      c.appikonDiscount.getAppikonDiscountData(o);
    }
    function a(t) {
      let e = !0;
      return (
        (t.includes("/cart.js") ||
          t.includes("/cart.json") ||
          t.includes("/cart/add") ||
          t.includes("/cart/update") ||
          (c.appikonDiscount.settings.is_dynamic_insertion &&
            t.includes("/cart/change")) ||
          t.includes("/cart/clear") ||
          t.endsWith("/cart") ||
          t.includes("/cart?")) &&
          !t.includes("/cart?view=appikon.json") &&
          (t.includes("/cart/add") ||
          t.endsWith("/cart") ||
          t.includes("/cart?")
            ? o
                .ajax({
                  cache: !1,
                  type: "GET",
                  url: "/cart.js",
                  dataType: "json",
                })
                .done(function (t) {})
                .fail(function (t, e, i) {
                  console.error(i);
                })
            : (e = !1)),
        e
      );
    }
    c.appikonDiscount.calculateDiscounts = () =>
      c.appikonDiscount.getAppikonDiscountData(o);
    var n,
      t = c.appikonDiscount.getCookie(
        "appikon_discount_" + c.appikonDiscount.settings.shop
      );
    if (
      (t && (c.appikon.discount_code = t), hasFlag("disable_checkout_button"))
    ) {
      let t = o(c.appikonDiscount.settings.global.appikonCheckoutSelector);
      t.val() || t.html();
      t.css("border-color"), t.css("background-color");
    }
    function s(e) {
      (c.appikon.adp_page = "product"),
        e.ajax({
          cache: !1,
          type: "POST",
          url: c.appikonDiscount.settings.app_root_url,
          data: JSON.stringify(c.appikon),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function (t) {
            c.appikonDiscount.appikonDelegate(e, t);
          },
        });
    }
    function r() {
      var t;
      o(p).ready(function () {
        if (c.appikonDiscount.settings.dp.installed)
          if (
            (c.appikonDiscount.settings.page_load_delay
              ? setTimeout(e, c.appikonDiscount.settings.page_load_delay)
              : e(),
            c.appikonDiscount.settings.listen_to_ajax_cart_events_strategy)
          ) {
            let t = c.XMLHttpRequest.prototype.open;
            c.XMLHttpRequest.prototype.open = function () {
              this.addEventListener("load", async function () {
                if (!a(this.responseURL)) {
                  let t = null;
                  try {
                    "blob" === this.responseType &&
                      (console.log("response type is blob..."),
                      (i = new Blob([this.response], {
                        type: "application/json",
                      })),
                      (t = await i.text()));
                  } catch (t) {
                    console.log(t);
                  }
                  null === t && (t = this.responseText);
                  var e,
                    i = JSON.parse(t);
                  !0 === c.appikonDiscount.settings.use_compare_at_price
                    ? ((e = await c.appikonDiscount.addCompareAtPrice(o, i)),
                      c.appikonDiscount.processCartData(o, e))
                    : c.appikonDiscount.processCartData(o, i);
                }
              }),
                t.apply(this, arguments);
            };
            const n = c.fetch;
            c.fetch = function () {
              return new Promise((e, i) => {
                n.apply(this, arguments)
                  .then((t) => {
                    a(t.url) ||
                      (o.ajax({
                        cache: !1,
                        type: "GET",
                        url: "/cart.js",
                        dataType: "json",
                      }),
                      c.appikonDiscount.settings.intercept_fetch_calls &&
                        t
                          .clone()
                          .json()
                          .then((t) => {
                            c.appikonDiscount.processCartData(o, t);
                          })),
                      e(t);
                  })
                  .catch((t) => {
                    i(t);
                  });
              });
            };
          } else setInterval(e, 1e3);
      }),
        c.appikon.adp_page &&
          "product" === c.appikon.adp_page &&
          0 < c.appikonDiscount.settings.dp.installed &&
          s(o),
        setTimeout(function () {
          "function" == typeof ga &&
            ga(function (t) {
              c.gaclientId = t.get("clientId");
            });
        }, 1e3),
        hasFlag("refresh_on_qty_plush_minus") &&
          (o(p).on(
            "click",
            c.appikonDiscount.settings.plus_minus_qty_selector,
            function () {
              let t = this;
              c.appikonDiscount.isAppikonCartPage &&
                setTimeout(function () {
                  o(t).parents('form[action*="/cart"]').submit();
                }, 500);
            }
          ),
          hasFlag("refresh_on_qty_change_hard")) &&
          ((c.appikonDiscount.cartSubmit = function () {
            c.appikonDiscount.isAppikonCartPage &&
              setTimeout(function () {
                o('form[action*="/cart"]').submit();
              }, 500);
          }),
          o(p).ready(function () {
            setTimeout(function () {
              let t,
                e = p.querySelectorAll(
                  c.appikonDiscount.settings.plus_minus_qty_selector
                );
              for (t = 0; t < e.length; t++)
                e[t].setAttribute(
                  "onclick",
                  "window.appikonDiscount.cartSubmit();"
                );
            }, 1200);
          })),
        c.appikonDiscount.isAppikonCartPage &&
          ((t =
            0 < o("div.cart__edit button.btn.cart__edit--active:visible").length
              ? ""
              : "input "),
          o(p).on(
            t + "change",
            "input.appikon-quantity, input[name^='updates['], input[id^='updates_'], input[id^='Updates_']",
            function (t) {
              let e = this;
              t.preventDefault(),
                "" != o.trim(o(this).val()) &&
                  setTimeout(function () {
                    hasFlag("enable_quantity_change_reload") &&
                      (hasFlag("quantities_refresh_over_submit")
                        ? c.location.reload()
                        : o(e).parents('form[action*="/cart"]').submit());
                  }, i());
            }
          ),
          o(p).on(
            "click",
            "td.cart-qty span.icon-plus, td.cart-qty span.icon-minus",
            function (t) {
              t.preventDefault(),
                o(this).parents('form[action*="/cart"]').submit();
            }
          ),
          c.appikonDiscount.settings.is_dynamic_insertion ||
            o(p).ajaxSuccess(function (t, e, i) {
              i && "/cart/change.js" == i.url && c.location.reload();
            }),
          1 != hasFlag("avoid_default_qty_input_event_change")) &&
          (setTimeout(function () {
            o(".js-qty__adjust").off("click");
          }, 500),
          o(p).on("click", "div.js-qty .js-qty__adjust", function (t) {
            (c.appikonDiscount.settings.avoid_cart_quantity_adjustment
              ? o(this).parents("div.js-qty").find("input")
              : (t.preventDefault(),
                (t = parseInt(
                  o(this).parents("div.js-qty").find("input").val()
                )),
                (t = o(this).hasClass("js-qty__adjust--plus") ? t + 1 : t - 1),
                o(this).parents("div.js-qty").find("input").val(t))
            ).change();
          })),
        o(p).on("click", "button#apply-appikon-discount", function (t) {
          t.preventDefault();
          (t = o(t.target).attr("data-identifier")),
            (t = o("input[id=" + t + "]:visible")
              .val()
              .trim());
          c.appikonDiscount.setCookieMinutes(
            "appikon_discount_" + c.appikonDiscount.settings.shop,
            t,
            5
          ),
            (c.appikon.discount_code = t),
            c.appikonDiscount.triggerDiscountCalculation(o);
        }),
        o(p).on("click", "div#appikon-close-notification", function (t) {
          t.preventDefault(),
            c.appikonDiscount.setCookie(
              "appikon_notifications_closed",
              1,
              0.01
            ),
            o("#appikon-notification-bar").slideUp("slow");
        }),
        o(p).on(
          "click",
          ".appikon-variants-container select.adp-variants",
          function () {
            o(this).children("option").length < 1 &&
              alert("All item variants are out of stock");
          }
        );
    }
    c.appikonDiscount.isAppikonCartPage &&
      (n = c.appikonDiscount.getCookie("adp-skip-ids")) &&
      (c.appikon.skip_ids = n),
      (c.appikonDiscount.loadProductPageApi = () => s(o)),
      (c.appikon.multicurrency = {}),
      c.Shopify &&
        c.Shopify.currency &&
        ((c.appikon.multicurrency.currency = c.Shopify.currency.active),
        (c.appikon.multicurrency.rate = c.Shopify.currency.rate),
        (c.appikon.multicurrency.locale = c.Shopify.locale),
        (c.appikon.multicurrency.country = c.Shopify.country)),
      c.theme && c.theme.moneyFormat
        ? (c.appikon.multicurrency.moneyFormat = c.theme.moneyFormat)
        : c.theme && c.theme.strings && c.theme.strings.moneyFormat
        ? (c.appikon.multicurrency.moneyFormat = c.theme.strings.moneyFormat)
        : c.Theme && c.Theme.strings && c.Theme.strings.moneyFormat
        ? (c.appikon.multicurrency.moneyFormat = c.Theme.strings.moneyFormat)
        : c.Theme && c.Theme.moneyFormat
        ? (c.appikon.multicurrency.moneyFormat = c.Theme.moneyFormat)
        : c.mwSwitcherObjects && c.mwSwitcherObjects.shop.money_format
        ? (c.appikon.multicurrency.moneyFormat =
            c.mwSwitcherObjects.shop.money_format)
        : c.Shopify.currency &&
          c.Shopify.currency.active &&
          c.Currency &&
          c.Currency.money_format &&
          c.Currency.money_format[c.Shopify.currency.active]
        ? (c.appikon.multicurrency.moneyFormat =
            c.Currency.money_format[c.Shopify.currency.active])
        : c.Currency &&
          c.Currency.currentCurrency &&
          c.Currency.moneyFormats &&
          c.Currency.moneyFormats[c.Currency.currentCurrency]
        ? (c.appikon.multicurrency.moneyFormat =
            c.Currency.moneyFormats[c.Currency.currentCurrency].money_format)
        : c.ACSCurrency && c.ACSCurrency.currentCurrency
        ? (c.appikon.multicurrency.moneyFormat =
            c.ACSCurrency.moneyFormats[
              c.ACSCurrency.currentCurrency
            ].money_format)
        : c.FlashsearchThemeSettings &&
          c.FlashsearchThemeSettings.shop &&
          c.FlashsearchThemeSettings.shop.moneyFormat &&
          (c.appikon.multicurrency.moneyFormat =
            c.FlashsearchThemeSettings.shop.moneyFormat),
      r();
  };
  if (
    "undefined" == typeof jQuery ||
    !jQuery ||
    void 0 === jQuery.ajax ||
    (1 === parseInt(jQuery.fn.jquery) &&
      parseFloat(jQuery.fn.jquery.replace(/^1\./, "")) < 10)
  ) {
    c.appikonDiscount.log(
      "jquery not found. loading jquery from: ajax.googleapis.com/ajax/libs/jquery/1.12.0/jquery.min.js"
    );
    let t = p.getElementsByTagName("head")[0],
      e = p.createElement("script");
    (e.src =
      ("https:" == p.location.protocol ? "https://" : "http://") +
      "ajax.googleapis.com/ajax/libs/jquery/1.12.0/jquery.min.js"),
      (e.type = "text/javascript"),
      (e.onload = e.onreadystatechange =
        function () {
          e.readyState
            ? ("complete" !== e.readyState && "loaded" !== e.readyState) ||
              ((e.onreadystatechange = null), i(jQuery.noConflict(!0)))
            : i(jQuery.noConflict(!0));
        }),
      t.appendChild(e);
  } else c.appikonDiscount.log("jquery already loaded on site"), i(jQuery);
})(window, document);
